import i18n from '../language/index'
import Store from '../vuex/store';
import PersonBase from './row';
import Col from './one_column';
import Row from './one_row';
import Module from './one_module';
import router from '@/router'

import {
  Message
} from 'element-ui';
import complex_style from '@/base/complex_style_list';
import link from './linkData'
import {gen_id, find_page} from "@/base/base";
import axios from 'axios'
import {
  p_init,
  p_save,
  navList,
  getProList,
  getArticleListBy1,
  getProTypeList,
  gettypeList,
  getForm,
  get_host,
  get_pags,
  get_QRCcode,
  get_home,
  get_anchor,
  save_anchor,
  getSearchsParams,
  editAtlasList,
  get_atlas,
  clearStatic,
  deleteNav,
  translatePage,
  getIcpInfo,
  get_material_detailed
} from '@/api/app';
import full_screen_banner from '@/widgets/full_screen_banner/banner_data.js';
import page_module_config from '@/base/page_module_config'
import font_family_position from '@/base/font_family_position'
import Cookies from 'js-cookie'
import {
  create_mb_header_data
} from '@/base/mb_header_data'
import {
  create_col_style
} from '@/base/col_style_data';

import {createEmptyTemplate} from './../utils/utils'
import emptyTemplateConfig from '@/view/left_sidebar/module/emptyTemplateConfig'

import VueKindEditor from 'vue-kindeditor'
import th from "element-ui/src/locale/lang/th";

if (process.env.NODE_ENV === 'row_jcp') {
  var my_path = require('../../config/index')
}
import floatingFrameStyle from "@/widgets/basic_floating_frame/style.js"
import store from "../vuex/store";
import contactUsStyle from '@/view/contact_us/style.js' // contact us 联系我们

export default class Person_Templet extends PersonBase {
  constructor(...args) {
    super(...args);
    let that = this;
  }

  p_init(fn) {
    // let widgets_id = null
    // if(Store.state.app.module_Data) {
    //   widgets_id = Store.state.app.module_Data.widgets_id
    // }
    //系统列表以及详情页面挂件参数
    const params = this.getPageDesignParams('init',fn)
    let obj = {
      page: router.history.current.name || Store.state.app.now_page,
      ...params
    };
    //初始化屏幕宽度的值
    if (Store.state.app.view_pattern === 'pc') {
      Store.state.app.screenWidth = $(window).width();
    } else {
      Store.state.app.screenWidth = 375;
    }
    Store.state.moduleAnimation.implement = [];
    // if(!(typeof fn === 'object' && typeof fn.designType !== 'undefined')) {
      //请求前先重置视图，以免渲染错误
      Store.commit('myRender/render_reset');

      //重置是否操作状态
      Store.commit("app/set_operation", false);
      //关闭窗口
      this.row_edit_close();
      this.dialog_close();
      this.main_dialog_reset();
      $.myMongoliaOpen();
    // }
    return p_init(obj).then((e) => {
      if (e.code == 200) {
        if (e.data instanceof Array) {
          //空模板
          //第一次进入是空模板
          this.data_null();
        } else if (e.data instanceof Object) {
          //头部
          if (e.data.header) {
            //存在则按数据渲染，反之则前端模拟创建
            Store.commit('myRender/SET_header', this.created_list({
              list: e.data.header,
              type: 'header'
            }));
          } else {
            this.create_sys_header()
          }

          //底部
          if (e.data.footer) {
            Store.commit('myRender/SET_footer', this.created_list({
              list: e.data.footer,
              type: 'footer'
            }));
          } else {
            this.create_sys_footer();
          }

          //横幅
          if (e.data.full_screen_banner) {
            // 有个字段放错位置了，为了兼容历史数据，位置不改，单独处理一下……
            let fullScreenBanner = this.created_list({
              list: e.data.full_screen_banner,
              type: 'full_screen_banner'
            });
            (fullScreenBanner || []).forEach((row, index) => {
              (row.children || []).forEach((item, index2) => {
                item.summary = e.data.full_screen_banner[index].children[index2].summary
              })
            });
            Store.commit('myRender/SET_full_screen_banner', fullScreenBanner);
          } else {
            this.created_full_screen_banner();
          }

          //中部
          if (e.data.body) {
            Store.commit('myRender/SET_body', this.created_list({
              list: e.data.body,
              type: 'body'
            }));
            // if(typeof fn === 'object' && typeof fn.designType !== 'undefined') {
            //   let module = this.getModuleByWidgetsId("body", widgets_id)
            //   this.p_$nextTick(() => {
            //     this.close_main_dialog(module, 'style');
            //   })
            // }
          } else {
            //初始化第一次的时候，页面是空
            this.create_body_row();
          }

          //公共
          if (e.data.common) {
            if (typeof e.data.common.mb_header_background === 'undefined') {
              e.data.common.mb_header_background = create_mb_header_data().mb_header_background;
            }

            if (typeof e.data.common.mb_header_btn_background === 'undefined') {
              e.data.common.mb_header_btn_background = create_mb_header_data().mb_header_btn_background;
            }

            if (typeof e.data.common.vip_type === 'undefined') {
              e.data.common.vip_type = 'default'
            }
            if (typeof e.data.common.vip_type_footer === 'undefined') {
              e.data.common.vip_type_footer = 'default'
            }
            if (typeof e.data.common.setting.multiLanguageOpen === 'undefined') {
              e.data.common.setting.multiLanguageOpen = false
            }
            if (typeof e.data.common.setting.zhLanguageOpen === 'undefined') {
              e.data.common.setting.zhLanguageOpen = false
            }
            if (typeof e.data.common.setting.zhLanguageAdress === 'undefined') {
              e.data.common.setting.zhLanguageAdress = ''
            }
            if (typeof e.data.common.setting.footnavOpen === 'undefined') {
              e.data.common.setting.footnavOpen = false
            }

            if (typeof e.data.common.theme_color_type === 'undefined') {
              let colorArr = Store.state.options.baseColor.filter(item => item.color == e.data.common.theme_color)
              e.data.common.theme_color_type = colorArr.length > 0 ? colorArr[0].key : 'default_1'
            }
            if (typeof e.data.common.mb_header_nav_position === 'undefined') {
              e.data.common.mb_header_nav_position = 'left'
            }
            if (typeof e.data.common.mb_header_nav_title === 'undefined') {
              e.data.common.mb_header_nav_title = {
                radio_val: 'default',
                default: {fontSize: 18},
                custom: {fontSize: 18}
              }
            }
            if (typeof e.data.common.icp_isShow === 'undefined') {
              get_home().then((res) => {
                if (res.code == 200 && res.data && res.data.inlineTime) {
                  if (parseInt(res.data.inlineTime) == 0 || parseInt(res.data.inlineTime) >= 1628766000) {
                    e.data.common.icp_isShow = 'true'
                  } else {
                    e.data.common.icp_isShow = 'false'
                  }
                  Store.commit('myRender/set_common', e.data.common);
                }
              })
            }
            // 公共的登录注册功能 是否存在
            if (typeof e.data.common.setting.loginRegister === 'undefined') e.data.common.setting.loginRegister = false;
            // contact us 联系 我们如果不存在 要进行初始化
            if (!e.data.common.contact_us) {
              e.data.common.contact_us = { // contact_us 联系我们新加的数据
                contact_us_show: false,
                contact_us_set: contactUsStyle.contact_us_set,
                listArr: contactUsStyle.listArr
              }
            }
            if (!e.data.common.adaptWidth) {
              e.data.common.adaptWidth = {
                isOpen: 'false',
                radioVal: 1200,
                val: 1200,
                customVal: 1440
              }
            } else { //兼容处理
              e.data.common.adaptWidth.radioVal = e.data.common.adaptWidth.radioVal !== 'custom' ? parseInt(e.data.common.adaptWidth.radioVal) : String(e.data.common.adaptWidth.radioVal)
              e.data.common.adaptWidth.val = parseInt(e.data.common.adaptWidth.val)
              e.data.common.adaptWidth.customVal = parseInt(e.data.common.adaptWidth.customVal)
            }
            if(typeof e.data.common.header_layout_row_setting === 'undefined' 
            || e.data.common.header_layout_row_setting == 'hovering'
            || e.data.common.header_layout_row_setting == 'placeholder') {
              e.data.common.header_layout_row_setting = 'zhanwei'
            }
            if(typeof e.data.common.xuanfu_position === 'undefined') {
              e.data.common.xuanfu_position = 'index'
            }
            if (typeof e.data.common.visitor_auth === 'undefined') {
              e.data.common.visitor_auth = 'show'
            }
            Store.commit('myRender/set_common', e.data.common);
          }

          // private字段没有数据的时候是空数组
          if (!e.data.private || (e.data.private && Array.isArray(e.data.private) && e.data.private.length === 0)) {
            e.data.private = {}
            e.data.private.banner_isShow = true
            e.data.private.banner_type = 'private'
          }
          if (e.data.private && !e.data.private.banner_type) {
            // 处理一些有问题的历史数据
            e.data.private.banner_type = 'private'
          }

          if (typeof e.data.private.fullPageTopNavType === 'undefined') {
            e.data.private.fullPageTopNavType = 'zhanwei'
            e.data.private.fullPageStyleType = '0'
            e.data.private.fullPageFooterType = String((e.data.common || {}).footer_display) === 'true' ? 'type0' : 'hidden'
          }
          e.data.private.fullPageFooterType = this.fixFullPageDefaultValue(e.data.private.fullPageFooterType)

          // 如果不存在 floatingFrameOpen
          // if (!e.data.private.floatingFrameOpen && e.data.private.floatingFrameOpen !== true) {
          if (typeof e.data.private.floatingFrameOpen === 'undefined' || !e.data.private.floatingFrameOpen) { //浮框隐藏之后保存的数据要重新覆盖初始化
            e.data.private.floatingFrameOpen = false
            e.data.private.floatingFrameStyle = {
              data: floatingFrameStyle,
              name: 'basic_floating_frame'
            }
          }

          Store.commit('myRender/set_private', e.data.private);

          //没数据的时候是返回数组
          if (e.data.private && typeof e.data.private.banner_type != 'undefined') {
            if (typeof e.data.private.fixed_background_isOpen === 'undefined') {
              e.data.private.fixed_background_isOpen = 'false'
            }

            if (typeof e.data.private.H1_isOpen === 'undefined') {
              e.data.private.H1_isOpen = false
            }

            Store.commit('myRender/set_private', e.data.private);
          }
          //页面设置初始化
          if(typeof e.data.designType == 'undefined') {
            Store.commit('app/SET_DESIGN_TYPE', 1);
          } else if(typeof fn === 'object' && typeof fn.designType !== 'undefined') {
            Store.commit('app/SET_DESIGN_TYPE', fn.designType);
          } else {
            Store.commit('app/SET_DESIGN_TYPE', e.data.designType);
          }

        }

        this.is_add_page_modules();

        if ($('.init_mongolia_layer').length > 0) {
          $('.init_mongolia_layer').remove();
        }
        // Store.dispatch('historical/historical_init_INSERT', this.p_$confirm);

        //第一次选模板后，全局颜色的挂件需要初始化一下
        this.global_color_for_module();

        // console.log('render数据', Store.state.myRender)
        // console.log('列排序', Store.state.myRender.body[0].data.col_order_array)

        this.p_$nextTick(() => {
          this.fixed_init();
          this.reset_header_set_data();
          Store.commit('app/SET_is_change', false);
          this.mb_eye_isShow();
          if (typeof fn === 'function') {
            fn();
          }
        })
      } else {
        this.showMessage(e)
      }
    }).catch((e) => {

      console.log('p_init错误', e)
    }).finally(() => {
      Store.commit('app/set_pageDataLoading', false)
      $.myMongoliaClose();
      //获取当前页面的预览地址
      this.get_host();
      //检测导航和网站标题是否存在
      //this.watch_has_title_nav();

      // 插入记录放最后，因为挂件数据有改动
      Store.dispatch('historical/historical_init_INSERT', this.p_$confirm);
    })
  }

  fixFullPageDefaultValue(fullPageFooterType) {
    let scrollType = Store.state.app.scrollType
    let footerTypeOptions = scrollType === 'col' ? Store.state.options.footerType : Store.state.options.rowFooterType
    if (!footerTypeOptions.some(item => item.value === fullPageFooterType)) {
      fullPageFooterType = scrollType === 'col' ? 'type0' : 'typeRow1'
    }
    return fullPageFooterType
  }

  zxt_toggle() {
    let symbol = '?'
    if (Store.state.preview.path.includes('?')) {
      symbol = '&'
    }
    axios.get(`${Store.state.preview.path}${symbol}m=wdata&a=zxtInfo`).then((response) => {
      const res = response.data
      const vipDay = res.day
      const vipSwitch = (res.switch || {}).pc === 1 ? true : false
      const vipLevel = Math.floor(vipDay / 365) + 1
      Store.commit('vip/set_vip_switch', vipSwitch)
      Store.commit('vip/set_vip_level', vipLevel)
      Store.commit('vip/set_vip_day', vipDay)
      // 如果关闭v标,挂件树默认default状态
      if (!vipSwitch) {
        Store.state.myRender.common.vip_type = 'default'
        Store.state.myRender.common.vip_type_footer = 'default'
      }
      // 头部vip标签
      this.create_vip_header()
      // 底部vip标签
      this.create_vip_footer()
    })
  }

  create_vip_header() {
    let basic_vip_header_module = this.use_name_find_module("header", 'basic_vip_header')
    if (basic_vip_header_module && !Store.state.vip.switch) {
      this.del_vip_header()
    }
    // 如果臻信通开启v标，如果有头部系统栏，并且使用自定义vip挂件， 并且没有头部vip挂件, 创建挂件
    if (Store.state.vip.switch && Store.state.myRender.common.header_display && Store.state.myRender.common.vip_type === 'custom' && !basic_vip_header_module) {
      let col = Store.state.myRender.header[0].children[0]
      Store.commit('app/ADD_widgets_id')
      basic_vip_header_module = new Module({
        name: 'basic_vip_header',
        pid: col.pid,
        widgets_id: Store.state.app.widgets_id,
        rowType: 'header'
      })
      col.children.push(basic_vip_header_module)
    }
  }

  del_vip_header() {
    const basic_vip_header = this.use_name_find_module(
      'header',
      'basic_vip_header'
    )
    // 从头部找到basic_vip_header所在的列
    let column
    let moduleIndex
    Store.state.myRender.header.map((row) => {
      row.children.map((col) => {
        col.children.map((module, index) => {
          if (module.widgets_id === basic_vip_header.widgets_id) {
            column = col
            moduleIndex = index
          }
        })
      })
    })
    this.del_module(column.widgets_id, moduleIndex)
  }

  create_vip_footer() {
    let basic_vip_footer_module = this.use_name_find_module("footer", 'basic_vip_footer')
    if (basic_vip_footer_module && !Store.state.vip.switch) {
      this.del_vip_footer()
    }
    // 如果臻信通开启v标，如果有底部系统栏，并且使用自定义vip挂件,并且没有头部vip挂件, 创建挂件
    if (Store.state.vip.switch, Store.state.myRender.common.footer_display && Store.state.myRender.common.vip_type_footer === 'custom' && !basic_vip_footer_module) {
      let col = Store.state.myRender.footer[0].children[0]
      Store.commit('app/ADD_widgets_id')
      basic_vip_footer_module = new Module({
        name: 'basic_vip_footer',
        pid: col.pid,
        widgets_id: Store.state.app.widgets_id,
        rowType: 'footer'
      })
      col.children.unshift(basic_vip_footer_module)
    }
  }

  del_vip_footer() {
    const basic_vip_footer = this.use_name_find_module(
      'footer',
      'basic_vip_footer'
    )
    // 从底部找到basic_vip_footer所在的列
    let column
    let moduleIndex
    Store.state.myRender.footer.map((row) => {
      row.children.map((col) => {
        col.children.map((module, index) => {
          if (module.widgets_id === basic_vip_footer.widgets_id) {
            column = col
            moduleIndex = index
          }
        })
      })
    })
    this.del_module(column.widgets_id, moduleIndex)
  }

  col_width_change(row) {
    const row_id = row.widgets_id;
    const that = this;
    $(`#u${row_id}`).find('.column_resize_handle').draggable({
      helper: "clone",
      axis: "x",
      drag(event, ui) {
        const dom_left = parseFloat($(this).css('left'));
        const helper_left = ui.position.left;
        const difference = 20;
        const difference_go_on = 40;
        const col_id = $(this).closest('.one_column').attr('data-id');
        const col_now_num = parseInt($(this).closest('.one_column').attr('col'));
        const col_befor_id = $(this).closest('.one_column').next().attr('data-id');
        const col_befor_num = parseInt($(this).closest('.one_column').next().attr('col'));
        const direction = Store.state.app.col_width_change.direction;
        const normal = Store.state.app.col_width_change.normal;
        //原始向左
        if (direction == '' && helper_left - dom_left < difference * -1 && col_now_num > 1) {
          //console.log('原始向左');
          that.to_left({
            col_id,
            col_now_num,
            col_befor_id,
            col_befor_num,
            dom_left
          });
          return

        }

        //继续向左
        else if (direction == 'left' && helper_left - dom_left < difference_go_on * -1 && col_now_num > 1) {
          //console.log('继续向左');
          that.to_left({
            col_id,
            col_now_num,
            col_befor_id,
            col_befor_num,
            dom_left
          });
          return
        }

        //反向向左
        else if (direction == 'right' && helper_left - normal < difference * -1 && col_now_num > 1) {
          //console.log('反向向左');
          that.to_left({
            col_id,
            col_now_num,
            col_befor_id,
            col_befor_num,
            dom_left
          });
          return
        }

        //原始向右
        else if (direction == '' && helper_left - dom_left > difference && col_befor_num > 1) {
          //console.log('原始向右');
          that.to_right({
            col_id,
            col_now_num,
            col_befor_id,
            col_befor_num,
            dom_left
          });
          return
        }

        //继续向右
        else if (direction === 'right' && helper_left - dom_left > difference_go_on && col_befor_num > 1) {
          //console.log('继续向右');
          that.to_right({
            col_id,
            col_now_num,
            col_befor_id,
            col_befor_num,
            dom_left
          });
          return
        }

        //反向向右
        else if (direction === 'left' && helper_left - normal > 0 && col_befor_num > 1) {
          //console.log('反向向右');
          that.to_right({
            col_id,
            col_now_num,
            col_befor_id,
            col_befor_num,
            dom_left
          });
          return
        }
        that.calculation_four_position(row_id);
        that.calculation_mongolia(row);
      },
      stop(event, ui) {
        Store.commit('app/SET_col_width_direction', '');
        Store.commit('app/SET_col_width_normal', 0);

        //同步store里的数据
        const rowType = $(this).closest('.one_column').attr('rowtype');
        const row = $(this).closest('.layout_row');
        const row_id = row.attr('data-id');
        const cols = row.find('.one_column');
        for (let i = 0; i < cols.length; i++) {
          const col = cols[i];
          const col_now_num = parseInt($(col).attr('col'));
          const col_id = $(col).attr('data-id');
          const col_obj = that.find_obj(col_id).target;
          if (col_obj) {
            col_obj.data.pc_infor.col = col_now_num;
          }

        }
      }

    })

  }

  to_left({
            col_id,
            col_now_num,
            col_befor_id,
            col_befor_num,
            dom_left
          }) {
    Store.commit('app/SET_col_width_direction', 'left');
    Store.commit('app/SET_col_width_normal', dom_left);

    $(`#u${col_id}`).removeClass(`pc_col_${col_now_num}`);
    $(`#u${col_id}`).addClass(`pc_col_${col_now_num - 1}`);
    $(`#u${col_id}`).attr('col', col_now_num - 1);

    $(`#u${col_befor_id}`).removeClass(`pc_col_${col_befor_num}`);
    $(`#u${col_befor_id}`).addClass(`pc_col_${col_befor_num + 1}`);
    $(`#u${col_befor_id}`).attr('col', col_befor_num + 1);
  }

  to_right({
             col_id,
             col_now_num,
             col_befor_id,
             col_befor_num,
             dom_left
           }) {
    Store.commit('app/SET_col_width_direction', 'right');
    Store.commit('app/SET_col_width_normal', dom_left);

    $(`#u${col_id}`).removeClass(`pc_col_${col_now_num}`);
    $(`#u${col_id}`).addClass(`pc_col_${col_now_num + 1}`);
    $(`#u${col_id}`).attr('col', col_now_num + 1);

    $(`#u${col_befor_id}`).removeClass(`pc_col_${col_befor_num}`);
    $(`#u${col_befor_id}`).addClass(`pc_col_${col_befor_num - 1}`);
    $(`#u${col_befor_id}`).attr('col', col_befor_num - 1);
  }

  //laybox大小 左右编辑
  laybox_sizeChange_rl(row, btn) {
    const that = this;
    const row_id = row.widgets_id;
    const screen = document.documentElement.clientWidth || document.body.clientWidth;
    let min = btn == 'left' ? 0 : screen * 0.6;
    let max = btn == 'left' ? screen * 0.4 : screen;

    $(`#u${row_id}`).find('.resize_' + btn).draggable({
      containment: 'parent',
      axis: 'x',
      containment: [min, 0, max, 200],
      create() {
        const laybox = $(this).parents('.layout_row').find('.laybox');
        that.calculation_top($(this), laybox);
      },
      drag(event, ui) {
        let to_num = parseFloat($(this).css(btn));  // 按钮的left值，如果按钮放在laybox里，这个值就是 内边距：to_num px；如果按钮放在layout_row里 这个值要减去laybox的offsetLeft 才是内边距

        to_num = to_num - $(this).parents('.layout_row').find('.laybox')[0].offsetLeft
        console.log('to_num:', to_num)
        if (to_num < 0) {
          // todo 这里没有起作用  有空再看   小于零的时候不能继续往左边拖动
          to_num = 0
          return
        }


        const s_w = document.documentElement.clientWidth || document.body.clientWidth;
        const laybox = $(this).parents('.layout_row').find('.laybox');
        let val = to_num / s_w * 100;
        console.log('val:', val)

        if (val >= 40) {
          val = 40;
        }
        $(this).parents('.layout_row').find('.laybox').css(`padding-${btn}`, val + '%');
        console.log(607, $(this).parents('.layout_row').find('.laybox'))
        that.calculation_four_position(row_id)
        that.laybox_sizeChange_background(btn, to_num, row_id);
        that.calculation_mongolia(row);
        that.left_right_tips($(this), btn);
      },
      stop(event, ui) {
        const laybox = $(this).parent().find('.laybox');
        that.laybox_sizeChange_back_hide(row_id);
        that.stop_change_data(row_id);
        that.calculation_top($(this), laybox); //拖拽的按钮无法调整位置，需要重置
        $(this).children('.my_tips').css('display', 'none');
      }
    })
  }

  left_right_tips($_this, btn) {
    let title = '';
    if (btn == 'left') {
      title = i18n.t('base_options_config_1678');
    } else if (btn == 'right') {
      title = i18n.t('base_options_config_1679');
    } else if (btn == 'top') {
      title = i18n.t('base_options_config_1676');
    } else if (btn == 'bottom') {
      title = i18n.t('base_options_config_1677');
    }
    const padding = parseInt($_this.parents('.layout_row').find('.laybox').css(`padding-${btn}`));
    $_this.children('.my_tips').css('display', 'block');
    $_this.children('.my_tips').text(i18n.t('base_row_y _ 副本_1923', [title,padding]));


  }

  //laybox大小 上编辑
  laybox_sizeChange_top(row) {
    const that = this;
    const row_id = row.widgets_id;
    $(`#u${row_id}`).find('.resize_top').draggable({
      containment: 'parent',
      axis: 'y',
      create() {
        const laybox = $(this).parent().find('.laybox');
        const laybox_p_t = laybox.css('padding-top');
        $(this).css('top', laybox_p_t);
        that.calculation_left($(this), laybox);

      },
      drag(event, ui) {
        const s_w = document.documentElement.clientWidth || document.body.clientWidth;
        const position = ui.position.top;
        const val = position / s_w * 100;
        $(this).parent().find('.laybox').css('padding-top', val + '%');
        that.calculation_four_position(row_id)
        that.laybox_sizeChange_background('top', position, row_id);
        that.calculation_mongolia(row);
        that.left_right_tips($(this), 'top');
      },
      stop(event, ui) {
        that.laybox_sizeChange_back_hide(row_id);
        that.stop_change_data(row_id);
        $(this).children('.my_tips').css('display', 'none');
      }
    })
  }

  //laybox大小 下编辑
  laybox_sizeChange_bottom(row) {
    const that = this;
    const row_id = row.widgets_id;
    $(`#u${row_id}`).find('.resize_bottom').draggable({
      axis: 'y',
      helper: "clone",
      zIndex: -1,
      create() {
        const laybox = $(this).parent().find('.laybox');

        that.calculation_bottomBtn_top($(this), laybox);
        that.calculation_left($(this), laybox);
      },
      start() {
        Store.state.app.laybox_paddingBottom = parseFloat($(this).parent().find('.laybox').css('padding-bottom'));
      },
      drag(event, ui) {
        const laybox = $(this).parent().find('.laybox');
        const s_w = document.documentElement.clientWidth || document.body.clientWidth;

        const resize_left = $(this).parent().find('.resize_left');
        const resize_right = $(this).parent().find('.resize_right');

        const now_top = parseFloat($(this).css('top'));
        const helper_top = ui.position.top;
        const end_num = helper_top - now_top + Store.state.app.laybox_paddingBottom;

        const val = end_num / s_w * 100;
        if (val >= 0) {
          $(this).parent().find('.laybox').css('padding-bottom', val + '%');
          that.laybox_sizeChange_background('bottom', end_num, row_id);
        }
        that.calculation_mongolia(row);
        that.left_right_tips($(this), 'bottom');

      },
      stop(event, ui) {
        that.laybox_sizeChange_back_hide(row_id);
        that.stop_change_data(row_id);
        $(this).children('.my_tips').css('display', 'none');

      }
    })
  }

  //计算上下
  calculation_top(that, laybox) {
    const laybox_p_t = parseFloat(laybox.css('padding-top'));
    const laybox_h = laybox.height(); //不含编剧
    const end_val = laybox_h / 2 + laybox_p_t;
    //that.css("cssText",`top:${end_val}px!important`);
    that.css({
      'top': `${end_val}px`
    });
  }

  //计算左右
  calculation_left(that, laybox) {
    const laybox_p_l = parseFloat(laybox.css('padding-left'));
    const laybox_w = laybox.width(); //不含边距
    console.log('laybox_w:', laybox_w)
    let left = laybox_w / 2 + laybox_p_l
    left = left + $(laybox).offset().left
    that.css('left', left + 'px');
  }

  //计算下面按钮的top
  calculation_bottomBtn_top(that, laybox) {
    const laybox_p_t = parseFloat(laybox.css('padding-top'));
    const laybox_height = laybox.height();
    that.css('top', laybox_p_t + laybox_height);
  }

  //改变大小时候的黑色背景
  laybox_sizeChange_background(type, size, row_id) {
    const dom = $(`#u${row_id}`).find('.padding_edit_block');
    if (type === 'top' || type === 'bottom') {
      dom.css({
        display: 'block',
        top: type === 'top' ? 0 : 'auto',
        bottom: type === 'bottom' ? 0 : 'auto',
        width: '100%',
        height: size + 'px'
      })
    } else if (type === 'left' || type === 'right') {
      let offsetLeft = $(`#u${row_id}`).find('.laybox').offset().left
      size = size + offsetLeft
      dom.css({
        display: 'block',
        top: 0,
        left: type === 'left' ? 0 : 'auto',
        right: type === 'right' ? 0 : 'auto',
        width: size + 'px',
        height: '100%'
      })
    }
  }

  laybox_sizeChange_back_hide(row_id) {
    const dom = $(`#u${row_id}`).find('.padding_edit_block');
    dom.css('display', 'none')
  }

  //停止后改变数据
  stop_change_data(row_id) {
    const obj = this.find_obj(row_id);

    const laybox = $(`#u${row_id}`).find('.laybox');
    const s_w = document.documentElement.clientWidth || document.body.clientWidth;
    // const s_w = laybox.outerWidth()
    const paddingLeft = parseFloat(laybox.css('padding-left'));
    const paddingRight = parseFloat(laybox.css('padding-right'));
    const paddingTop = parseFloat(laybox.css('padding-top'));
    const paddingBottom = parseFloat(laybox.css('padding-bottom'));
    if (obj) {
      obj.target.data.pc_infor.box_paddingLeft = paddingLeft / s_w * 100 + '%';
      obj.target.data.pc_infor.box_paddingRight = paddingRight / s_w * 100 + '%';
      obj.target.data.pc_infor.box_paddingTop = paddingTop / s_w * 100 + '%';
      obj.target.data.pc_infor.box_paddingBottom = paddingBottom / s_w * 100 + '%';
    }

  }

  //新增列
  add_col(row) {
    const row_id = row.widgets_id;
    Store.commit('app/ADD_widgets_id');
    const col = new Col({
      widgets_id: Store.state.app.widgets_id,
      rowType: row.rowType,
      pid: row_id
    });
    if (row.isNewRow && row.newType === 'row2') {
      col.isNewCol = true
      col.newType = 'col2'
    }

    //新增列的判断
    const cols = row.children;
    if (cols.length == 8) {
      Message.error(i18n.t('base_row_y _ 副本_1924'))
      return;
    }


    if (cols.length == 2) {
      this.add_col_judge(4, row, col, cols);
    } else if (cols.length == 3) {
      this.add_col_judge(3, row, col, cols);
    } else if (cols.length == 1) {
      this.add_col_judge(6, row, col, cols);
    }else if(cols.length == 4){
      this.add_col_judge(5, row, col, cols);
    }else if(cols.length == 5){
      this.add_col_judge(4, row, col, cols);
    }else if(cols.length == 6){
      this.add_col_judge(3, row, col, cols);
    }else if(cols.length >= 7){
      this.add_col_judge(2, row, col, cols);
    }

    //插入列排序
    row.data.col_order_array.push(col.data.col_id);
    // 这边我需要遍历一下修改 order 还存在一个问题 col_order_array 可能会存在 不应该存在的数据
    let col_id_arr = cols.map(item => item.data.col_id);
    if(row.data.col_order_array.length === 0)  row.data.col_order_array = [...col_id_arr]
    row.data.col_order_array = row.data.col_order_array.filter(id => col_id_arr.includes(id))
    row.data.col_order_array.forEach((item,i)=> {
      cols.forEach(col => {
        if(col.data.col_id === item) col.data.mb_infor.order = i
      })
    })
    //绑定栏目宽度调整
    this.p_$nextTick(() => {
      this.col_width_change(row);
      this.calculation_four_position(row_id);
      this.calculation_mongolia(row);
    })
  }

  //重新计算layout-box padding的拖拽点
  calculation_four_position(row_id) {
    const resize_left = $(`#u${row_id}`).find('.resize_left');
    const resize_right = $(`#u${row_id}`).find('.resize_right');
    const resize_bottom = $(`#u${row_id}`).find('.resize_bottom');
    const resize_top = $(`#u${row_id}`).find('.resize_top');
    const laybox = $(`#u${row_id}`).find('.laybox');
    this.calculation_top(resize_left, laybox);
    this.calculation_top(resize_right, laybox);
    this.calculation_bottomBtn_top(resize_bottom, laybox);
    this.calculation_left(resize_top, laybox);
    this.calculation_left(resize_bottom, laybox);
  }

  row_has_module(row, name) { // 判断 row 是否含有某个挂件
    let cols = row.children || []
    let result;
    for (let i = 0; i < cols.length; i++) {
      let col = cols[i]
      for (let j = 0; j < col.children.length; j++) {
        let module = col.children[j]
        if (module.name === name) {
          result = module
          break;
        }
      }
    }
    return result
  }

  add_col_judge(num, row, col, cols) {
    this.set_col_num(cols, num);
    col.data.pc_infor.col = num;
    if (row.rowType === 'header' && this.row_has_module(row, 'basic_loginregister')) { // 头部通栏 的 头部登录注册组件 只能在右边
      row.children.unshift(col);
    } else {
      row.children.push(col);
    }
  }

  set_col_num(cols, num, type = 'pc_infor') {
    cols.map((item) => {
      item.data[type].col = num;
    })
  }

  add_row(row_index, click_row) {
    if (!click_row) {
      console.error(i18n.t('base_row_y _ 副本_1925'))
    }
    const rowType = click_row.rowType;
    const {
      row,
      col
    } = this.create_blank_row(rowType);
    //如果是顶部或底部，则默认颜色就是透明
    // if (rowType == 'header' || rowType == 'footer') {
    //   row.data.pc_infor.row_background_set.default.color = 'rgba(255, 255, 255, 0)';
    //   row.data.mb_infor.row_background_set.default.color = 'rgba(255, 255, 255, 0)';
    //   col.data.pc_infor.background_set.default.color = 'rgba(255, 255, 255, 0)';
    // }

    //一般是加载下方，但是如果点击的是底部系统通栏，那么就加上上面
    if (click_row && click_row.data && click_row.data.is_system == 'true') {
      Store.state.myRender[rowType].splice(row_index - 1, 0, row);
    } else {
      Store.state.myRender[rowType].splice(row_index, 0, row);
    }

    if (Store.state.app.scrollType === 'normal') {
      this.p_$nextTick(() => {
        this.row_scroll(row.widgets_id);
      });
    }

    return {
      row,
      col
    };
  }

  create_blank_row(rowType) {
    Store.commit('app/ADD_widgets_id');
    const row = new Row({
      widgets_id: Store.state.app.widgets_id,
      rowType
    });

    //生成一个col
    Store.commit('app/ADD_widgets_id');
    const col = new Col({
      widgets_id: Store.state.app.widgets_id,
      rowType,
      pid: row.widgets_id
    });
    row.children.push(col);
    row.data.col_order_array.push(col.data.col_id)
    return {
      row,
      col
    };

  }

  col_has_child(col_id) {
    let hasChild = false;
    const target = this.find_obj(col_id) ? this.find_obj(col_id).target : null;
    if (target && target.children && target.children.length > 0) {
      hasChild = true;
    }
    return hasChild;
  }


  //module排序
  module_sortable(col_id, modules_dom) {
    const that = this;

    let sort_dom = {};
    if (modules_dom) {
      sort_dom = modules_dom;
    } else {
      sort_dom = $(`#u${col_id}`).find('.modules');
    }

    //如果是底部包含basic_copyright的列，不绑定排序
    // const rowtype = $(`#u${col_id}`).attr('rowtype');
    // const data_type = $(`#u${col_id}`).attr('data-type');
    // if (rowtype == 'footer' && data_type == 'has_system_module') {
    //   return;
    // }
    //:not(.module_disabled_sortable)


    sort_dom.sortable({
      items: ".module:not(.module_disabled_sortable)",
      //appendTo: "body",
      //helper: "clone",
      placeholder: 'module_placeholder',
      connectWith: '.sort_modules',
      //containment:'window',
      scroll: false,
      cancel: '.form_item_wrapm,input,textarea,.tooptipPart,.margin_btn,.draggable_my_tips',
      tolerance: 'pointer',
      distance: 5,
      create(event, ui) {
        //手机端不能排序
        if (Store.state.app.view_pattern === 'mb') {
          $(this).sortable({disabled: true});
        }

      },

      start(event, ui) {
        if ($('.material-agent').length == 0) {
          const dom = ui.helper.clone();
          const box = $('<div class="material-agent"></div>');
          const zoom = 200 / dom.width();

          const dom_h = dom.outerHeight();
          const small_h = dom_h * zoom;
          const margin_top = (dom_h / 2) - (small_h / 2)
          dom.css({
            'transform': zoom > 1 ? 'scale(1)' : `scale(${zoom}) `,
          });
          box.css({
            'transform': zoom > 1 ? 'translateY(0px)' : `translateY(${margin_top}px)`,
          })

          if ($('.material-agent').length == 0 && !dom.hasClass('add_module_item') && !dom.hasClass('add_module_layout')) {
            box.append(dom);
            $("body").append(box);
          }

        }
      },

      sort(event, ui) {
        const make = ui.item.attr('data-make');
        if (make === 'add_sort') {
          that.mouse_drag(event);
        }
      },

      over(event, ui) {
        //改变placeholder高度
        //const hasChild = that.col_has_child($(this).attr('data-id'));
        const hasChild = $(this).children('.module').length;
        // console.log('over', hasChild);
        if (hasChild == 0) {
          //没有子集
          $(this).find('.module_placeholder').addClass('noChild');
          $(this).parent().find('.column_no_child_frame').css('display', 'none');
        } else {
          $(this).find('.module_placeholder').removeClass('noChild');
        }
        if ($(event.target).parents('.basic_row_tab').length) {
          const moduleName = ui.item.attr('data-name');
          if (moduleName === 'basic_row_tab' || moduleName === 'basic_floating_frame') {
            $('.module_placeholder').addClass('module_placeholder_disable')
          }
        }

      },
      out(event, ui) {
        //const hasChild = that.col_has_child($(this).attr('data-id'));
        const hasChild = $(this).children('.module').length;
        // console.log('over', hasChild);
        if (hasChild == 0) {
          //没有子集
          $(this).parent().find('.column_no_child_frame').css('display', 'block');
        } else {
          $(this).find('.module_placeholder').removeClass('noChild');
        }
        $('.module_placeholder').removeClass('module_placeholder_disable')
      },


      receive(event, ui) {
        // console.log('receive: \n event:', event, '\n ui:', ui)

        if (Store.state.app.scrollType !== 'normal') {
          if (!$(this).parents('.layout_row,.myBanner').hasClass('fullpage-slide-current') && !$(this).parents('.layout_footer').hasClass('my-footer-active') && !$(this).parents('.myheader').length) {
            // 全屏滚动所有的slide都用绝对定位堆在一起，用opacity: 0;visibility: hidden;隐藏非当前slide，但是还能响应receive事件，所以要return
            return
          }
        }

        if ($(this).parents('.tab-panel').length && !$(this).parents('.tab-panel').eq(0).hasClass('tab-panel-active')) {
          // 横向标签非当前的tab是用opacity: 0;visibility: hidden;隐藏的，还可以响应receive事件，所以要return
          return;
        }

        $('.material-agent').remove();

        const make = ui.item.attr('data-make');
        let col_id = $(this).attr('data-id');
        if ($(event.target).parents('.basic_row_tab').length) {
          // 如果是往横向标签中拖动

          const name = ui.item.attr('data-name');
          if (name === 'basic_row_tab' || name === 'basic_floating_frame') {
            // 往横向标签中添加横向标签，不允许
            return;
          }
          if (make === 'add_module') { // 从挂件弹窗中拖新的挂件到横向标签中
            let col_id = $(event.target).parents('.basic_row_tab').attr('data-id')
            that.add_module_to_row_tab($(event.target), ui)
            $('.material-agent').remove();
          } else {
            // 页面中已经存在的挂件，拖动到横向标签中
            let colId = $(this).attr('data-id') || $(this).find('.modules').attr('data-id');
            that.sortable_data(colId);
            $('.material-agent').remove();
          }
          return;
        }

        if (make === 'add_module') {
          if (ui.helper) {
            const add_index = ui.helper.index();
            ui.helper.remove();
            const name = ui.item.attr('data-name');
            that.add_module(col_id, add_index, name);
          }
        } else {
          that.sortable_data(col_id);
        }

      },

      stop(event, ui) {
        $('.material-agent').remove();
        const make = ui.item.attr('data-make');
        if (make === 'add_sort') {
          if ($(this).parents('.basic_row_tab').length) {
            // 处理从横向标签中移出的挂件

            let moduleId = $(ui.item).attr('data-id')
            let panelColumnId = $(this).attr('data-id')

            if ($(this).find('#u' + moduleId).length) {
              // 只是在内部拖动不需要处理
              let col_id = $(this).attr('data-id')
              that.sortable_data(col_id);
              return;
            }

            // 拖到外面其他column里去了
            setTimeout(() => {
              let panelColumn = that.find_obj(panelColumnId, ['body'])
              if (panelColumn) {
                panelColumn = panelColumn.target
              } else {
                return
              }
              let index = panelColumn.children.findIndex(module => String(module.widgets_id) === String(moduleId))
              panelColumn.children.splice(index, 1)
            }, 20)
            return
          } else {
            let col_id = $(this).attr('data-id')
            if ($(ui.item).eq(0).hasClass('basic_row_tab')) {
              // console.log('现在拖的是横向标签')
              if ($(ui.item).eq(0).parents('.basic_row_tab').length) {
                // console.log('横向标签加在横向标签里了')
                // console.log('data:', Store.state.myRender.body)
                /// 数据正常 页面显示不正常 只处理dom就行了,恢复dom好像有点难？ 直接重新渲染一下
                const find_obj = that.find_obj(col_id);
                const col_obj = find_obj.target;
                let temp = col_obj.children
                col_obj.children = [];
                that.p_$nextTick(() => {
                  col_obj.children = temp;
                })
                return;
              }
            }
            that.sortable_data(col_id);
          }
        }


        //导航等对sort限制了，这里打开限制
        that.open_sort();
      }
    })
  }

  row_tab_sortable() {

  }

  add_module_to_row_tab($panel, ui) {
    let make = ui.item.attr('data-make');
    let col_id = $panel.parents('.basic_row_tab').attr('data-id')
    let tabIndex = Number($panel.attr('data-index'))
    if (ui.helper) {
      const add_index = ui.helper.index();
      ui.helper.remove();
      const name = ui.item.attr('data-name');
      let option = {
        isRowTag: true,
        tabIndex,
      }
      this.add_module(col_id, add_index, name, option);
    }
  }

  // row排序(通栏排版)
  row_sortable(col_id, modules_dom) {
    const that = this
    let sort_dom = $('.mybody')
    sort_dom.sortable({
      items: ".layout_row",
      placeholder: 'add_row_placeholder',
      scroll: false,
      cancel: '.form_item_wrapm,input,textarea,.tooptipPart,.margin_btn,.draggable_my_tips',
      tolerance: 'pointer',
      distance: 5,
      create(event, ui) {
        //手机端不能排序
        if (Store.state.app.view_pattern === 'mb') {
          $(this).sortable({disabled: true});
        }
      },
      start(event, ui) {
        if ($('.material-agent').length == 0) {
          const dom = ui.helper.clone();
          const box = $('<div class="material-agent"></div>');
          const zoom = 200 / dom.width();
          const dom_h = dom.outerHeight();
          const small_h = dom_h * zoom;
          const margin_top = (dom_h / 2) - (small_h / 2)
          dom.css({
            'transform': zoom > 1 ? 'scale(1)' : `scale(${zoom}) `,
          });
          box.css({
            'transform': zoom > 1 ? 'translateY(0px)' : `translateY(${margin_top}px)`,
          })

          if ($('.material-agent').length == 0 && !dom.hasClass('add_module_layout')) {
            box.append(dom);
            $("body").append(box);
          }

        }
      },

      sort(event, ui) {
        // console.log('sort')
        const make = ui.item.attr('data-make');
        if (make === 'add_sort') {
          that.mouse_drag(event);
        }
      },

      over(event, ui) {
        const hasChild = $(this).children('.module').length;
        if (hasChild == 0) {
          //没有子集
          $(this).find('.module_placeholder').addClass('noChild');
          $(this).parent().find('.column_no_child_frame').css('display', 'none');
        } else {
          $(this).find('.module_placeholder').removeClass('noChild');
        }
      },
      out(event, ui) {
        const hasChild = $(this).children('.module').length;
        if (hasChild == 0) {
          //没有子集
          $(this).parent().find('.column_no_child_frame').css('display', 'block');
        } else {
          $(this).find('.module_placeholder').removeClass('noChild');
        }
      },

      receive(event, ui) {
        let addType = ui.item.attr('data-name')
        if (addType === 'layout_row') {
          if(Store.state.app.scrollType !== 'normal' && Store.state.app.view_pattern === "pc") { //新增全屏通栏
              const page = [...document.querySelectorAll('#full-page-nav li')];
              if(page.length > 14) {
                that.p_$message.warning(i18n.t('view_left_sidebar_module_add_module_243'))
                return
              }
          }
          if (Store.state.app.scrollType === 'normal') {
            let index = ui.helper.index()
            that.add_row(index, Store.state.myRender.body[index + 1] || Store.state.myRender.body[index - 1] || Store.state.myRender.body[index])
          } else {
            let fullPageCurrentIndex = Store.state.app.fullPageCurrentIndex
            let bodyRowIndex = Math.max(fullPageCurrentIndex - 1, 0)
            that.add_row(fullPageCurrentIndex, Store.state.myRender.body[bodyRowIndex] || Store.state.myRender.body[bodyRowIndex - 1])

            setTimeout(() => {
              window.fullPage.resetData()
              window.fullPage.resetHeight()
              if (Store.state.myRender.private.banner_isShow) {
                // 如果有横幅，就要往下滚一页
                window.fullPage.next()
              }
            })
          }
          $('.material-agent').remove()
          ui.helper && ui.helper.remove()
        } else if (addType === 'material') {
          let id = ui.item.attr('data-id');
          let type = ui.item.attr('data-type')
          let option = {
            id, type
          }

          that.getMaterialDetail(option).then(data => {
            if (data) {
              let index
              if (Store.state.app.scrollType === 'normal') {
                index = ui.helper.index()
              } else {
                let fullPageCurrentIndex = Store.state.app.fullPageCurrentIndex
                index = fullPageCurrentIndex //Math.max(fullPageCurrentIndex - 1, 0)
              }

              ui.helper.remove()
              data.rowType = 'body';
              const new_row = that.copy_one_row(data);
              that.global_color_for_module_make([data])
              Store.state.myRender.body.splice(index, 0, new_row);

              if (Store.state.app.scrollType !== 'normal') {
                setTimeout(() => {
                  window.fullPage.resetData()
                  window.fullPage.resetHeight()
                  if (Store.state.myRender.private.banner_isShow) {
                    // 如果有横幅，就要往下滚一页
                    window.fullPage.next()
                  }
                })
              }
            }
          })
        }

        return

        // 下面的代码好像没有用，暂时留着，上线运行一段时间确定没影响后 下个版本再删掉
        const make = ui.item.attr('data-make');
        const col_id = $(this).attr('data-id');
        $('.material-agent').remove();
        if (make === 'add_module') {

        } else {
          that.sortable_data(col_id);
        }
      },

      stop(event, ui) {
        // console.log('stop')
        $('.material-agent').remove();
        const make = ui.item.attr('data-make');
        if (make === 'add_sort') {
          that.sortable_data($(this).attr('data-id'));
        }

        if (ui.item.hasClass('layout_row')) {
          /// 对通栏拖动排序
          // console.log('对通栏拖动排序')
          that.handle_sort_row()
        }

        //导航等对sort限制了，这里打开限制
        that.open_sort();
      }
    })
  }

  getMaterialDetail(option) {
    if (option.type === 'empty') {
      return this.getEmptyMaterialDetail(option)
    } else {
      return this.getNormalMaterialDetail(option)
    }
  }

  getEmptyMaterialDetail(option) {
    let config = emptyTemplateConfig.find(d => {
      return String(d.id) === String(option.id)
    })
    this.detail = createEmptyTemplate(config.scheme)
    return new Promise((r) => {
      r(this.detail)
    })
  }

  getNormalMaterialDetail(option = {}) {
    return get_material_detailed({
      group_id: option.id
    }).then((e) => {
      if (e.code == 200 && e.data && Array.isArray(e.data) && e.data.length > 0) {
        let obj = null;
        try {
          obj = JSON.parse(e.data[0].params)
        } catch (e) {
          console.log(e)
        }
        if (obj) {
          let index
          if (Store.state.app.scrollType === 'normal') {
            // index = ui.helper.index()
          } else {
            // let fullPageCurrentIndex = Store.state.app.fullPageCurrentIndex
            // index = fullPageCurrentIndex //Math.max(fullPageCurrentIndex - 1, 0)
          }

          // ui.helper.remove()
          const type = 'body';
          obj.rowType = type;
          const new_row = this.copy_one_row(obj);
          this.global_color_for_module_make([new_row])
          // Store.state.myRender.body.splice(index, 0, new_row);
          return new_row
        }
      }
    }).catch((err) => {
      console.error(err)
    })
  }

  handle_sort_row() {
    let oldRowList = Store.state.myRender.body.slice()
    let idList = $('.mybody').children('.layout_row').map((index, el) => {
      return Number($(el).attr('data-id'))
    })
    idList = $.makeArray(idList)
    let newRowList = oldRowList.sort((a, b) => {
      return idList.indexOf(a.widgets_id) - idList.indexOf(b.widgets_id)
    })
    Store.state.myRender.body = []
    this.p_$nextTick(() => {
      Store.state.myRender.body = newRowList
    })
  }

  open_sort() {
    //导航等对sort限制了，这里打开限制
    if (Store.state.row.sort_disabled) {
      const doms = $('.sort_modules');
      for (let i = 0; i < doms.length; i++) {
        $(doms[i]).sortable({
          "disabled": false
        });
      }
      Store.commit('row/set_sort_disabled', false);
      console.log('放开所有挂件排序')
    }

  }

  sortable_data(col_id, tabColId) {
    const modules = $(`#u${col_id}`).find('.modules').first().children('.module').not('.ui-sortable-helper');
    const rowType = $(`#u${col_id}`).attr('rowtype') || 'body';
    let find_arr = []
    if (rowType == 'full_screen_banner') {
      find_arr = ['full_screen_banner', 'common.full_screen_banner']
    } else {
      find_arr = [rowType];
    }
    let find_obj = this.find_obj(col_id, find_arr); //浅查找，只在当前rowType查找
    // 如果浅查找找不到，进行深查找（横幅挂件等的 rowType 可能不是 'full_screen_banner'）
    if (!find_obj) {
      find_obj = this.find_obj(col_id);
    }

    if (find_obj) {
      const col_obj = find_obj.target;

      //let sort_befor_ids = [];//排序后的id数组
      let new_modules = [];

      for (let i = 0; i < modules.length; i++) {
        const module_id = $(modules[i]).attr('data-id');


        let hasModule = false;
        //在当前col下，查找这个module,看看能否找得到
        for (let j = 0; j < col_obj.children.length; j++) {
          const m = col_obj.children[j];
          if (m.widgets_id == module_id) {
            m.rowType = rowType;
            m.pid = col_id;
            new_modules.push(m);
            hasModule = true;
            break;
          }
        }

        //如果找不到，那么这个module是从别的col拉进来的，要全局去找
        if (!hasModule) {
          //由于不知道是从哪里拖进来的，进行深查找
          const f_module = this.find_obj(module_id);
          if (f_module) {
            const module = f_module.target;
            module.rowType = rowType;
            module.pid = col_id;
            new_modules.push(module);
          }
        }

      }

      // 清除所有不必要的元素
      $(`#u${col_id}`).find('.modules').first().children().remove();

      this.basic_copyright_to_bottom(new_modules);

      //给col重新赋值
      //清除数据，重新赋值
      col_obj.children = [];
      this.p_$nextTick(() => {
        col_obj.children = new_modules;
      })

      // col_obj.children = new_modules;

    }
  }


  basic_copyright_to_bottom(arr) {
    //如果是底部包含copyright的列，就要把copyright放最后一个
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].name == 'basic_copyright') {
        const basic_copyright = arr.splice(i, 1)[0];
        arr.push(basic_copyright);
        break;
      }
    }
  }

  //新增module 这个地方 要新增判断 产品详情页面 以及 文章详情
  add_module(col_id, add_index, name, option = {}) {

    const find_obj = this.find_obj(col_id);
    if (find_obj) {
      const col = find_obj.target;
      Store.commit('app/ADD_widgets_id');
      const new_module = new Module({
        name,
        pid: col_id,
        widgets_id: Store.state.app.widgets_id,
        rowType: col.rowType
      });
      if (name === 'basic_row_tab') {
        new_module.children = new_module.data.listArr.tabs.map((tab) => {
          Store.commit('app/ADD_widgets_id');
          return new Col({
            widgets_id: Store.state.app.widgets_id,
            rowType: col.rowType,
            pid: col_id,
            tabId: tab.id
          })
        })
      }

      let isFullPage = Store.state.app.scrollType !== 'normal'
      // 如果是点击空通栏的“添加模块”按钮，add_index是9999 就算是通栏里的第一个模块，也是9999
      if (isFullPage && (add_index === 0 || col.children.length === 0)) {
        let isTopRow = !$(`#u${col.widgets_id}`).parent('.layout_row_2').length || $(`#u${col.widgets_id}`).parent('.layout_row_2').index() === 0
        let headerIsXuanfu = String(Store.state.myRender.private.fullPageTopNavType) === 'xuanfu'
        let headerIsFixed = String(Store.state.myRender.common.fixed_header) === 'true'
        let fullPageCurrentIndex = Store.state.app.fullPageCurrentIndex
        let isNotInBasicRowTab = !$(`#u${col.widgets_id}`).parent('.basic_row_tab').length
        let needDefaultMarginTop = isTopRow && isNotInBasicRowTab && headerIsXuanfu && (headerIsFixed || fullPageCurrentIndex === 0)
        if (needDefaultMarginTop) {
          new_module.data.pc_infor.marginTop = $('.myheader').height() + 'px'
        }
      }

      if ($(`#u${col.widgets_id}`).width() < 300) {
        new_module.data.pc_infor.marginLeft = parseInt(new_module.data.pc_infor.marginLeft) !== 0 ? '10%' : '0'
        new_module.data.pc_infor.marginRight = parseInt(new_module.data.pc_infor.marginRight) !== 0 ? '10%' : '0'
      }

      if (option.isRowTag) {
        col.children[option.tabIndex].children.splice(add_index, 0, new_module)
      } else {
        col.children.splice(add_index, 0, new_module);
      }

      this.basic_copyright_to_bottom(col.children);
      //col.children = [];
      this.p_$nextTick(() => {
        //col.children = modules;
        //部分挂件主题色复写
        if (name === 'basic_button' || name === 'basic_searchs') {
          this.complex_style_cover(new_module);
        }

        if (name === 'basic_text_rich_type') {
          setTimeout(()=> {
            Store.commit('font_style/SET_bold', false);
            Store.commit('font_style/SET_italics', false);
            Store.commit('font_style/SET_underline', false);
            let index = 0;
            KindEditor.instances.map((e, i) => {
              if (e.srcElement[0].id === 'editor' + new_module.widgets_id) {
                index = i;
              }
            });
            let _KindEditor = KindEditor.instances[index];
            if(_KindEditor) {
              _KindEditor.focus();
              if (_KindEditor.cmd.range.collapsed) {
                _KindEditor.cmd.selectall();
              }
              this.set_focus(new_module.widgets_id);
            }
          },300)
        }

        //打开编辑弹窗
        if (name != 'basic_picture') {
          this.changeStyle(new_module);
        }
        if (name == 'basic_picture') {
          Store.state.left_sidebar.dialogVisible = false;

        }
      })
      let router_name = router.history.current.name || Store.state.app.now_page; //当前页面路由
      // 产品详情 和文章详情 添加 basic_article_list', 'basic_product_display 这两个模块的时候 需要 修改 style 的 默认数据 条件改为标签选择 还要判断 是哪个站 现在先用中文站开发 之后使用外贸站 == 1
      if (name === 'basic_article_list' && ['product', 'article', 'help', 'case'].indexOf(router_name) !== -1 ) {
        new_module.data.listArr.addArticleType = 'system'
      }
      if (name === 'basic_product_display' && ['product', 'article', 'help', 'case'].indexOf(router_name) !== -1){
        new_module.data.listArr.type = 'system'
      }
    }

  }

  mouse_drag(event, class_name = 'material-agent') {
    const mouse_x = event.clientX;
    const mouse_y = event.clientY;
    const material_height = $('.' + class_name).height();
    const material_width = $('.' + class_name).width();

    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
    $('.' + class_name).css('top', mouse_y - (material_height / 2) + scrollTop + 'px');
    if (mouse_x < screenWidth - (material_width / 2) && mouse_x > material_width / 2) {
      $('.' + class_name).css('left', mouse_x - (material_width / 2) + 'px');
    }
  }

  //左边栏绑定拖拽
  left_sidebar_draggable() {
    const that = this;
    const body = $('body')
    $('.modular').find('.add_module_item').draggable({
      connectToSortable: '.sort_modules',
      helper: "clone",
      distance: 5,
      start(event, ui) {
        if ($('.left_sidebar_draggable_icon').length == 0) {
          const dom = ui.helper.clone();
          dom.addClass('left_sidebar_draggable_icon');
          dom.attr('id', 'left_sidebar_icon');
          $("body").append(dom);
        }
      },
      drag(event, ui) {
        that.mouse_drag(event, 'left_sidebar_draggable_icon');
      },
      stop(event, ui) {
        $('.left_sidebar_draggable_icon').remove();
        $('.sort_modules').find('.add_module_item.ui-draggable-handle').remove();
      }
    });

    this.row_sortable()
    $('.modular').find('.add_module_layout').draggable({
      connectToSortable: '.mybody',
      helper: "clone",
      distance: 0,
      start(event, ui) {
        if ($('.left_sidebar_draggable_icon').length == 0) {
          const dom = ui.helper.clone();
          dom.addClass('left_sidebar_draggable_icon');
          dom.attr('id', 'left_sidebar_icon');
          $("body").append(dom);
        }
      },
      drag(event, ui) {
        that.mouse_drag(event, 'left_sidebar_draggable_icon');
      },
      stop(event, ui) {
        $('.left_sidebar_draggable_icon').remove();
        $('.sort_modules').find('.add_module_layout.ui-draggable-handle').remove();
      }
    });

  }

  //判断通栏是否在编辑状态
  change_resize_bottom($_this) {
    if ($_this.parents('.layout_row').hasClass('row_editing')) {
      const row_id = $_this.parents('.layout_row').attr('data-id');
      const row = {
        widgets_id: row_id
      }
      this.calculation_mongolia(row);
      this.calculation_four_position(row_id);
    }

  }

  module_top_btn(module_id) {
    const that = this;
    $(`#u${module_id}`).children('.change_size_show_dom').find('.change_margin_top_btn').draggable({
      axis: 'y',
      helper: "clone",
      zIndex: -1,
      start() {
        that.draggable_start_Y($(this), module_id);
        that.dialog_close();
        that.aline_start(that, $(`#u${module_id}`), '.module');
        $(this).addClass('change_margining')
      },
      drag(event, ui) {
        //处理上下
        that.draggable_drag_Y($(this), module_id, ui);

        that.use_aline_drag(module_id);

        //判断通栏是否在编辑状态
        that.change_resize_bottom($(this));

      },
      stop() {
        const view_pattern = Store.state.app.view_pattern;
        const find_obj = that.find_obj(module_id);
        that.p_remove_line();
        Store.commit('align/clear_targetDom');
        $('#one_style').remove();
        $(this).removeClass('change_margining')

        that.draggable_end_Y(find_obj, view_pattern);

        $(this).closest('.layout_row').find('.column_operation_line').removeClass('column_operation_line_show')

      }
    })
  }

  module_left_btn(module_id) {
    const that = this;

    $(`#u${module_id}`).children('.change_size_show_dom').find('.change_margin_left_btn').draggable({
      axis: 'x',
      helper: "clone",
      zIndex: -1,
      start() {
        //处理左右
        that.draggable_start_X(module_id);
        that.dialog_close();
        that.aline_start(that, $(`#u${module_id}`), '.module');
        $(this).addClass('change_margining');
      },
      drag(event, ui) {

        //处理左右
        that.draggable_drag_X($(this), module_id, ui);

        that.use_aline_drag(module_id);

        //判断通栏是否在编辑状态
        that.change_resize_bottom($(this));


      },
      stop() {
        const find_obj = that.find_obj(module_id);
        const view_pattern = Store.state.app.view_pattern;
        that.p_remove_line();
        Store.commit('align/clear_targetDom');
        $('#one_style').remove();
        $(this).removeClass('change_margining')
        that.draggable_end_X(find_obj, view_pattern);
        $(this).parents('.layout_row').find('.column_operation_line').removeClass('column_operation_line_show')
        $(this).parents('.module').removeClass('moving')
      }

    })
  }


  use_aline_drag(module_id) {
    const module = $(`#u${module_id}`);
    const dragLeft = module.offset().left;
    const dragTop = module.offset().top;
    const dragWidth = module.width();
    const dragHeight = module.height();
    this.aline_drag(null, module, dragLeft, dragTop, dragWidth, dragHeight);
  }


  left_top_margin_tips($_this, type, is_draggable) {
    const num = parseInt($_this.parents('.module').css(`margin-${type}`));
    const row_height = $_this.parents('.layout_row').outerHeight();
    if (is_draggable == 'left_top') {
      const l = parseInt($_this.parents('.module').css(`margin-left`));
      const t = parseInt($_this.parents('.module').css(`margin-top`));
      $_this.children('.my_tips').html(i18n.t('base_row_y _ 副本_1926', [t,l,row_height]));
    } else {
      $_this.children('.my_tips').html(`${i18n.t('base_row_y _ 副本_1927', [type == 'top' ? i18n.t('base_options_config_1676') : i18n.t('base_options_config_1678'), num, row_height])}`);
    }


  }

  tooptipPart_position($_this) {
    const $module = $_this.closest('.module');
    const tooptipPart = $module.find('.tooptipPart').eq(0);
    if (tooptipPart.length > 0) {
      const w = $module.width();

      if (w / 2 < 130 || $module.hasClass('basic_text_rich_type')) {
        const index = $module.index()
        let $parent = $module.parent()
        const offsetBottom = ($parent.offset().top + $parent.height()) - ($module.offset().top + $module.height());
        if (index === 0 && $module[0].offsetTop < 30 && offsetBottom > 30) {
          tooptipPart.addClass('tooptipPart_to_bottom')
          tooptipPart.removeClass('tooptipPart_to_top')
        } else {
          tooptipPart.addClass('tooptipPart_to_top')
          tooptipPart.removeClass('tooptipPart_to_bottom')
        }
      } else {
        tooptipPart.removeClass('tooptipPart_to_bottom')
        tooptipPart.removeClass('tooptipPart_to_top')
      }
      let picTextNeedBottom = $module.hasClass('basic_rich_text') && ($module.height() < 60)
      if (picTextNeedBottom) {
        tooptipPart.addClass('tooptipPart_to_bottom')
        tooptipPart.removeClass('tooptipPart_to_top')
      } else {
        tooptipPart.removeClass('tooptipPart_to_bottom')
        tooptipPart.removeClass('tooptipPart_to_top')
      }

    }
  }

  module_size_btn(module) {
    const module_id = module.widgets_id;
    const module_name = module.name;
    const vuex_module = Store.state.module;


    let type = 'ordinary'; //special:用于按钮和搜索挂件调整大小 ordinary:普通模式
    if (vuex_module.drag_special.indexOf(module_name) > -1) {
      type = 'special';
    }
    if (module_name == 'basic_searchs' && Store.state.app.view_pattern == 'mb') {
      type = 'ordinary';
    }

    const that = this;
    $(`#u${module_id}`).children('.change_size_show_dom').find('.change_size_btn').draggable({
      helper: "clone",
      axis: type === 'special' ? false : 'x',
      zIndex: -1,
      create() {
        that.tooptipPart_position($(this));
      },
      start(event, ui) {
        const module = $(this).closest('.module');
        const module_margin_right = parseFloat(module.css('margin-right'));
        const data_button_lock = $(this).closest('.module').attr('data-button-lock');
        vuex_module.module_marginRight = module_margin_right;
        vuex_module.btn_left = parseFloat($(this).css('left'));

        //用于按钮和搜索挂件调整大小
        if (type === 'special') {
          vuex_module.btn_special.top = parseFloat($(this).css('top'));
          vuex_module.btn_special.height = $(this).closest('.module').find('.height_fill').height();
        }


        //算出宽度最小值
        const module_margin_left = parseFloat(module.css('margin-left'));
        const modules_width = $(this).closest('.layout_column').width();
        const min = (modules_width - (module_margin_left + 30)) / modules_width;
        const m_name = $(this).closest('.module').attr('data-name');
        vuex_module.min_width = min * 100;
        that.dialog_close();
        that.aline_start(that, $(`#u${module_id}`), '.module');

        if (m_name == 'basic_button' && data_button_lock == 'true') {
          Store.state.module.button_zoom = module.height() / module.width();
        }


      },
      drag(event, ui) {
        const modules_width = $(this).closest('.layout_column').width();
        const helper_left = ui.position.left;
        const data_button_lock = $(this).closest('.module').attr('data-button-lock');
        const m_name = $(this).closest('.module').attr('data-name');

        const end_num = vuex_module.module_marginRight - (helper_left - vuex_module.btn_left);
        const val = end_num / modules_width * 100;
        if (val > 0) {
          let r = val > vuex_module.diff_val ? val : 0;
          if (r >= vuex_module.min_width) {
            r = vuex_module.min_width;
          }
          vuex_module.drag_val.right = r;
          $(this).closest('.module').css('margin-right', r + '%');

          //用于按钮和搜索挂件调整大小
          if (type === 'special') {
            if (m_name == 'basic_button' && data_button_lock == 'true') {
              const h = $(this).closest('.module').width() * Store.state.module.button_zoom;
              vuex_module.drag_val.height = h;
              $(this).closest('.module').find('.height_fill').css('height', h);

            } else {
              const helper_top = ui.position.top;
              let h = vuex_module.btn_special.height + (helper_top - vuex_module.btn_special.top);
              if (h <= 30) {
                h = 30;
              }
              vuex_module.drag_val.height = h;
              $(this).closest('.module').find('.height_fill').css('height', h);
            }
          }

          //虚线要出现
          $(this).closest('.module').find('.change_size_show_dom').addClass('line_frame_show');
          if ($(document).height() - $(this).offset().top <= 60) {
            $(this).closest('.module').find('.tips_size').addClass('tips_size_touch_bottom');
          } else {
            $(this).closest('.module').find('.tips_size').removeClass('tips_size_touch_bottom');
          }
          that.change_size_tips($(this), event);
          that.use_aline_drag(module_id);
          that.tooptipPart_position($(this));

        }

      },
      stop() {
        const view_pattern = Store.state.app.view_pattern;
        const find_obj = that.find_obj(module_id);
        if (find_obj) {
          const obj = find_obj.target;
          if (vuex_module.drag_val.right != null) {

            obj.data[`${view_pattern}_infor`].marginRight = vuex_module.drag_val.right + '%';
            vuex_module.drag_val.right = null;
          }

          //用于按钮和搜索挂件调整大小
          if (vuex_module.drag_val.height != null && type === 'special') {
            //按钮挂件pc和mb高度一样，搜索挂件mb下高度写死,所以绑定数据都用pc_infor下的height就行
            obj.data.pc_widgets_infor.height = vuex_module.drag_val.height;
            vuex_module.drag_val.height = null;

          }
        }

        //虚线要出现
        $(this).closest('.module').find('.change_size_show_dom').removeClass('line_frame_show');
        that.p_remove_line();
        Store.commit('align/clear_targetDom');
        $(this).closest('.layout_row').find('.column_operation_line').removeClass('column_operation_line_show');
        $(this).closest('.module').removeClass('moving')
      }
    })
  }

  change_size_tips($_this, event) {
    const module = $_this.closest('.module');
    const row = $_this.closest('.layout_row');
    const w = module.width();
    const h = module.height();
    const row_h = row.outerHeight();
    const tips = module.find('.tips_size');
    const tips_w = tips.innerWidth();
    const tips_h = tips.innerWidth();
    module.find('.width_num').text(i18n.t('base_row_y _ 副本_1928') + w + 'px');
    module.find('.height_num').text(i18n.t('base_row_y _ 副本_1929') + h + 'px');
    module.find('.row_height_num').text(i18n.t('base_row_y _ 副本_1930') + row_h + 'px');
    const clientX = event.clientX;
    const clientY = event.clientY;

    let max_x = 0;
    let max_y = 0;
    if (Store.state.app.view_pattern === 'pc') {
      max_x = $(document).width();
      max_y = $(window).height();
    } else {
      max_x = $('.important_part').width() + $('.important_part').offset().left;
      max_y = $('.important_part').height() + $('.important_part').offset().top;

    }
    tips.removeClass('top_left');
    tips.removeClass('bottom_right');
    tips.removeClass('bottom_left');
    tips.removeClass('top_right');

    if (max_x - clientX <= tips_w && max_y - clientY <= tips_h) {
      tips.addClass('top_left');
    } else if (max_x - clientX > tips_w && max_y - clientY <= tips_h) {
      tips.addClass('top_right');
    }

    if (max_x - clientX <= tips_w && max_y - clientY > tips_h) {
      tips.addClass('bottom_left');
    } else if (max_x - clientX > tips_w && max_y - clientY > tips_h) {
      tips.addClass('bottom_right');
    }


    // console.log(max_x,max_y)

  }

  getNavList() {
    return navList({noDomain: 1}).then(res => {
      if (res.code == 200) {
        Store.commit('app/set_navListData', res.data);
        let data = this.getWebsiteSection(res.data)
        Store.commit('app/set_website_section', data);
        let threeLevelData = this.getThreeLevelWebsiteSection(res.data)
        Store.commit('app/set_threeLevelNavList', threeLevelData);
      } else {
        this.p_$message.success(res.message);
      }
    }).catch(err => {
    });
  }

  getWebsiteSection(data) {
    let temp = []
    data.forEach(item => {
      temp.push({
        id_: item.id,
        id: item._id,
        name: item.name,
        link: item.link,
        display_name: item.name,
        routerPath: item.theme_name,
        module: item.module
      })
      if (item.children && item.children.length > 0) {
        item.children.forEach(child => {
          let routerPath = ''
          let theme_name = child.theme_name
          if (theme_name === 'product_index') {
            routerPath = theme_name + '?id=' + child.tid + '&name=' + child.name
          } else if (theme_name === 'article_index' || theme_name === 'help_index' || theme_name === 'case_index') {
            routerPath = theme_name + '?typeId=' + child.tid
          } else {
            routerPath = theme_name
          }
          temp.push({
            id_: child.id,
            id: child._id,
            name: child.name,
            link: child.link,
            display_name: '　|-' + child.name,
            routerPath: routerPath,
            module: child.module
          })
        })
      }
    })
    return temp
  }

  getThreeLevelWebsiteSection(data) {
    let temp = []
    data.forEach(item => {
      // 一级导航
      temp.push({
        id_: item.id,
        id: item._id,
        name: item.name,
        link: item.link,
        display_name: item.name,
        routerPath: item.theme_name,
        module: item.module
      })
      // 二级导航
      if (item.children && item.children.length > 0) {
        item.children.forEach(child => {
          let routerPath = ''
          let theme_name = child.theme_name
          if (theme_name === 'product_index') {
            routerPath = theme_name + '?id=' + child.tid + '&name=' + child.name
          } else if (theme_name === 'article_index' || theme_name === 'help_index' || theme_name === 'case_index') {
            routerPath = theme_name + '?typeId=' + child.tid
          } else {
            routerPath = theme_name
          }
          temp.push({
            id_: child.id,
            id: child._id,
            name: child.name,
            link: child.link,
            display_name: '　|-' + child.name,
            routerPath: routerPath,
            module: child.module
          })
          // 三级导航
          if (child.children && child.children.length > 0) {
            child.children.forEach(grandChild => {
              let grandRouterPath = ''
              let grand_theme_name = grandChild.theme_name
              if (grand_theme_name === 'product_index') {
                grandRouterPath = grand_theme_name + '?id=' + grandChild.tid + '&name=' + grandChild.name
              } else if (grand_theme_name === 'article_index' || grand_theme_name === 'help_index' || grand_theme_name === 'case_index') {
                grandRouterPath = grand_theme_name + '?typeId=' + grandChild.tid
              } else {
                grandRouterPath = grand_theme_name
              }
              temp.push({
                id_: grandChild.id,
                id: grandChild._id,
                name: grandChild.name,
                link: grandChild.link,
                display_name: '　||-' + grandChild.name,
                routerPath: grandRouterPath,
                module: grandChild.module
              })
            })
          }
        })
      }
    })
    return temp
  }

  getProduct() {
    getProList({
      noDomain: 1,
      page: 1,
      rows: 9999,
      is_up: 'true' // 选择链接这边产品看到了未发布的产品
    }).then(res => {
      if (res.code == 200 && res.data.rows instanceof Array) {
        let temp = []
        res.data.rows.forEach(item => {
          temp.push({
            id: item.goods_id,
            name: item.name,
            link: item.url,
            display_name: item.name,
            routerPath: 'product?id=' + item.goods_id
          })
        })
        Store.commit('app/set_pro_list', temp);
      }
    }).catch(err => {
    });
  }

  /* 1: 新闻(article_index) 2:帮助(help_index) 3: 案例(case_index)*/
  getArticle(type = 1) {
    let data_type = 'article'
    if (type == 2) {
      data_type = 'help'
    } else if (type == 3) {
      data_type = 'case'
    }
    getArticleListBy1({
      type: type,
      noDomain: 1,
      is_up: 'true',
      page: 1,
      rows: 9999
    }).then(res => {
      if (res.code == 200 && res.data.rows instanceof Array) {
        let temp = []
        res.data.rows.forEach(item => {
          temp.push({
            id: item.id,
            name: item.title,
            link: item.url,
            display_name: item.title,
            routerPath: data_type + '?id=' + item.id
          })
        })
        Store.commit('app/set_' + data_type + '_list', temp);
      }
    }).catch(err => {
    });
  }

  /* 1: 新闻(article_index) 2:帮助(help_index) 3: 案例(case_index)*/
  getArticleType(type = 1) {
    let temp = []
    let data_type = 'article'
    if (type == 2) {
      data_type = 'help'
    } else if (type == 3) {
      data_type = 'case'
    }
    gettypeList({
      type: type
    }).then(res => {
      if (res.code == 200 && res.data.list instanceof Array) {
        let data = this.getTreeData(res.data.list, temp, data_type + '_index')
        Store.commit('app/set_' + data_type + '_type_list', data);
      }
    }).catch(err => {
    });
  }

  getProType() {
    getProTypeList().then(res => {
      if (res.code == 200 && res.data.rows instanceof Array) {
        let temp = []
        let data = this.getTreeData(res.data.rows, temp, 'product_index')
        Store.commit('app/set_pro_type_list', data);
      }
    }).catch(err => {
    });
  }

  getTreeData(data, temp, type) {
    let str = '?id='
    let linkType = '/' + type.replace('_index', '')
    data.forEach(item => {
      let routerPath = ''
      if (type === 'article_index'
        || type === 'help_index'
        || type === 'case_index') {
        routerPath = type + '?typeId=' + item.id
      } else if (type === 'product_index') {
        routerPath = type + '?id=' + item.id + '&name=' + item.name
      }
      if (item.hide === 'false') {
        temp.push({
          id: item.id,
          name: item.name,
          content: item.content,
          content_top: item.content_top,
          link: item.url,
          display_name: item.name,
          routerPath: routerPath
        })
      }
      if (item.children && item.children.length > 0) {
        this.getTreeData(item.children, temp, type)
      }
    })
    return temp
  }

  getFormList() {
    return new Promise((resolve, reject) => {
      getForm().then(res => {
        if (res.code == 200 && res.data.rows instanceof Array) {
          res.data.rows.forEach(item => {
            item.fields = JSON.parse(item.fields)
            if (!item.label) {
              item.label = item.title
              item.value = item.id
            }
            if(typeof item.fields.verifyCodeShow == 'undefined') {
              item.fields.verifyCodeShow = true
            }
            item.fields = JSON.stringify(item.fields)
          })
          resolve(res.data.rows)
          Store.commit('app/set_form_list', res.data.rows);
        } else {
          reject()
        }
      }).catch(err => {
        reject()
      });
    })
  }

  //当返回的是空模板
  data_null() {
    this.create_sys_header();
    this.create_sys_footer();
    this.created_full_screen_banner();
    this.create_body_row();
  }

  //生成系统头部
  create_sys_header() {
    const row = this.sys_row_init('header');
    const col_left = this.create_sys_module('header', row, 'basic_webtitle', 6);
    const col_right = this.create_sys_module('header', row, 'basic_navbar', 6);
    row.children.push(col_left);
    row.children.push(col_right);
    Store.state.myRender.header.push(row);
  }

  //生成系统挂件
  create_sys_module(rowType, rowHeader, name, col_num) {
    Store.commit('app/ADD_widgets_id');
    const col = new Col({
      widgets_id: Store.state.app.widgets_id,
      rowType,
      pid: rowHeader.widgets_id
    });
    col.data.pc_infor.col = col_num;

    Store.commit('app/ADD_widgets_id');
    const module = new Module({
      widgets_id: Store.state.app.widgets_id,
      rowType,
      pid: col.widgets_id,
      name
    });
    module.data.isSystem = 'true';
    col.children.push(module);
    return col;
  }

  create_mb_basic_searchs(headerSearchOpen){
    let basic_searchs = this.use_name_find_module("header", 'basic_searchs');
    if(!basic_searchs && headerSearchOpen){
      let module_Data = Store.state.myRender.header[0];
      let col = module_Data.children[0]
      Store.commit('app/ADD_widgets_id')
      basic_searchs = new Module({
        name: 'basic_searchs',
        pid: col.pid,
        widgets_id: Store.state.app.widgets_id,
        rowType: 'header'
      })
      basic_searchs.data.pc_widgets_infor.styleType = "type_6"
      basic_searchs.data.isMbSystem = "true"
      col.children.unshift(basic_searchs)
    }else{
      if (!headerSearchOpen) {
        this.del_module_data('header', basic_searchs)
      }
    }
  }

  create_login_register() { // 创建登录头部的 系统通栏
    let basic_loginregister = this.use_name_find_module("header", 'basic_loginregister'); // 判断 是否    
    const setting = Store.state.myRender.common.setting
    if (!basic_loginregister && (setting.shoppingCart || setting.loginRegister)) {
      let module_Data = Store.state.myRender.header[0];
      if (module_Data && module_Data.children.length < 4) {
        this.add_col(module_Data);
      }
      let col = module_Data.children[module_Data.children.length - 1]
      Store.commit('app/ADD_widgets_id')
      basic_loginregister = new Module({
        name: 'basic_loginregister',
        pid: col.pid,
        widgets_id: Store.state.app.widgets_id,
        rowType: 'header'
      })
      col.children.push(basic_loginregister)
    } else {
      if (!setting.shoppingCart && !setting.loginRegister) {
        this.del_module_data('header', basic_loginregister)
      }
    }
    return;
    if (!basic_loginregister) { // 存在头部通栏 删除数据  不能删除 单个组件 只能选择这个隐藏整个通栏
      let row = this.sys_row_init('header'); // 创建 系统通栏 row
      row.data.is_system = false
      let col_left = this.create_sys_module('header', row, 'basic_loginregister', 12); // 创建col 以及 module
      row.children.push(col_left);
      Store.state.myRender.header.unshift(row); // 保证头部注册的挂件处于 最顶部
    } else { // 删掉头部登录注册的头部
      // Store.state.myRender.header.shift();
    }

  }

  //生成中部的row
  create_body_row() {
    Store.commit('app/ADD_widgets_id');

    //初始化一个row
    const row = new Row({
      widgets_id: Store.state.app.widgets_id,
      rowType: 'body',
    });

    Store.commit('app/ADD_widgets_id');
    const col = new Col({
      widgets_id: Store.state.app.widgets_id,
      rowType: 'body',
      pid: row.widgets_id
    });
    col.data.pc_infor.col = 12
    row.children.push(col)
    Store.state.myRender.body.push(row);

    //this.p_save();
    this.p_$message.warning({
      showClose: true,
      message: i18n.t('base_row_y _ 副本_1931')
    });

  }

  //生成系统底部
  create_sys_footer() {
    const row = this.sys_row_init('footer');
    const col = this.create_sys_module('footer', row, 'basic_copyright', 12);
    row.children.push(col);
    Store.state.myRender.footer.push(row);
  }

  //初始化系统通栏
  sys_row_init(rowType) {
    Store.commit('app/ADD_widgets_id');
    const row = new Row({
      widgets_id: Store.state.app.widgets_id,
      rowType,
    });
    row.data.is_system = 'true';//系统通栏标志位
    this.set_row_config(row)
    return row;
  }

  set_row_config(row) {
    const page = Store.state.app.now_page;
    if (!page || !page_module_config[page]) {
      return
    }
    const rowConfig = page_module_config[page].rowConfig;
    if (rowConfig) {
      rowConfig.pcPaddingLeft && (row.data.pc_infor.box_paddingLeft = rowConfig.pcPaddingLeft);
      rowConfig.pcPaddingRight && (row.data.pc_infor.box_paddingRight = rowConfig.pcPaddingRight);
    }
  }

  //创建系统栏目，并增加系统挂件判断
  create_sys_row_sys_module() {
    const page = Store.state.app.now_page;
    const row = this.sys_row_init('body');
    const modules = page_module_config[page].modules;
    row.data.body_system_row = 'true';//body下的系统通栏，不能编辑通栏，只能加一列
    modules.map((item) => {
      const module = this.create_sys_module('body', row, item.name, item.col);
      row.children.push(module);
    })
    Store.state.myRender.body.push(row);


  }


  created_list({
                 list,
                 type
               }) {
    let arr = [];
    if (!list && list.length <= 0) {
      return arr;
    }

    for (let i = 0; i < list.length; i++) {
      const row = this.created_one_row(list[i], type);
      //列排序兼容初始化，手机端列样式初始化兼容
      this.col_order_array_init(row);
      arr.push(row);

    }
    return arr;
  }

  //根据指定数据创建row
  created_one_row(row, type) {
    let children = [];
    if (type === 'header' && this.row_has_module(row, 'basic_loginregister')) {
      //delete
      row.data.is_system = false
    }
    let data = row.data && row.data instanceof Object ? row.data : {};

    if (row.children && row.children instanceof Array) {
      children = this.created_col(row, type);
    }

    let new_row = new Row({
      name: row.name,
      name_: row.name_,
      widgets_id: row.widgets_id,
      theme_eare_name: row.theme_eare_name,
      rowType: type,
      isNewRow: row.isNewRow,
      newType: row.newType,
      children,
      data,
    });

    return new_row;
  }

  created_col(row, type) {
    let cols = []
    for (let i = 0; i < row.children.length; i++) {
      const col = row.children[i];
      let children = [];
      let data = col.data && col.data instanceof Object ? col.data : {};
      if (col.children && col.children instanceof Array) {
        if (col.isNewCol && col.newType === 'col1') {
          children = this.created_list({
            list: col.children,
            type: type
          });
        } else {
          children = this.created_module(col, type);
        }
      }

      const new_col = new Col({
        widgets_id: col.widgets_id,
        rowType: type,
        pid: row.widgets_id,
        isNewCol: col.isNewCol,
        newType: col.newType,
        data,
        children
      });
      cols.push(new_col);
    }
    return cols;

  }

  created_module(col, type) {

    let modules = [];
    if(!col.children)return []
    col.children = col.children.filter(item => item.name !== "basic_floating_frame") //过滤浮框之前是挂件的数据 清除数据
    for (let i = 0; i < col.children.length; i++) {
      const module = col.children[i];
      let data = module.data && module.data instanceof Object ? module.data : {};
      const new_module = new Module({
        widgets_id: module.widgets_id,
        rowType: type,
        pid: col.widgets_id,
        data,
        name: module.name
      });
      if (module.name === 'basic_row_tab') {
        for (var j = 0; j < module.children.length; j++) {          
          module.children[j]['children'] = this.created_module(module.children[j], type)
        }
        new_module.children = module.children
      }
      modules.push(new_module);
    }

    return modules;


  }

  /*
   * 对齐线，放到开始拖拽里的
   * that:使用方法的vue对象
   * $this：当前拖拽的元素
   * */
  aline_start(that, $this, dom) {
    //一开始拖拽的时候，就把同屏幕的dom找出来
    var thisId = $this.attr('data-id');
    //窗口卷去高度
    var srcollTop = $(window).scrollTop();
    var moduleArr = $(dom);
    //that.targetDom = [];
    Store.commit('align/clear_targetDom');

    //在刚开始拖拽的时候，找出屏幕范围内，所有的方块，把它们的信息插入到一个数组中，在拖拽时，就遍历这个数组，而不是遍历所有的dom,在100个左右的dom情况下，性能会更好
    for (var i = 0; i < moduleArr.length; i++) {
      var moduleHeight = moduleArr.eq(i).height(); //每个方块的高度
      var moduleTop = moduleArr.eq(i).offset().top; //每个方块距离文档顶部的距离
      var screenTop = moduleTop - srcollTop; //每个方块距离屏幕顶部的距离
      var module_id = moduleArr.eq(i).attr('data-id');
      //记录每个方块的信息，用于遍历计算
      var module_data = {
        id: module_id,
        width: moduleArr.eq(i).width(),
        height: moduleHeight,
        top: moduleTop,
        left: moduleArr.eq(i).offset().left,
      };
      if (screenTop + moduleHeight > 0 && screenTop < this.screenHeight && module_id != thisId) {
        Store.commit('align/add_targetDom', module_data);
      }

      //module的对齐线
      // if (dom === '.module') {
      //   //在当前屏幕范围内的方块，去除拖拽的那个
      //   if (screenTop + moduleHeight > 0 && screenTop < this.screenHeight && module_id != thisId) {
      //     Store.commit('align/add_targetDom', module_data);
      //     //that.targetDom.push(module_data);
      //   }

      // } else {
      //   const dom_i = $this.index();
      //   if (i != dom_i) {
      //     Store.commit('align/add_targetDom', module_data);
      //     //that.targetDom.push(module_data);
      //   }
      // }
    }
  }

  //删除线
  p_remove_line() {
    if ($('.align_line').length > 0) {
      $('.align_line').remove();
    }
  }

  /*
   * 竖向一根对齐线
   * target_top:目标元素的top
   * target_height:目标元素的height
   * dragTop:拖拽元素的top
   * dragHeight:拖拽元素的height
   * dragLeft:拖拽元素的left
   * dragLeft:拖拽元素的left
   * lineLeft：竖向对齐线的left值
   * */
  left_right_line(target_top, target_height, dragTop, dragHeight, lineLeft) {

    //如果目标方块在拖拽方块上面
    if (target_top < dragTop) {
      this.p_create_line({
        type: 'vertical',
        size: dragTop + dragHeight - target_top + 20,
        top: target_top - 10,
        left: lineLeft
      });
    } else {
      this.p_create_line({
        type: 'vertical',
        size: target_top + target_height - dragTop + 20,
        top: dragTop - 10,
        left: lineLeft
      });
    }


  }

  /*
   * 横向向一根对齐线
   * */
  top_bottm_line(dragLeft, dragWidth, target_left, target_width, lineLeft) {

    //如果目标方块在拖拽方块左面
    if (target_left < dragLeft) {
      this.p_create_line({
        type: 'transverse',
        size: dragLeft + dragWidth - target_left + 20,
        top: lineLeft,
        left: target_left - 10
      });
    } else {
      this.p_create_line({
        type: 'transverse',
        size: target_left + target_width - dragLeft + 20,
        top: lineLeft,
        left: dragLeft - 10
      });
    }
  }

  p_create_line(param) {
    let type = param.type;
    let size = param.size;
    let top = param.top;
    let left = param.left;

    var line = $('<div class="align_line"></div>');
    //var line = $('.align_line')
    //type代表是横线还是竖线
    if (type == 'transverse') {
      line.css({
        width: size + 'px',
        height: '1px',
        top: top,
        left: left
      });
    } else {
      line.css({
        width: '1px',
        height: size + 'px',
        top: top,
        left: left
      });
    }
    if (Store.state.app.view_pattern == 'pc') {
      line.appendTo('body');
    } else {
      line.appendTo('#app_child_frame');
    }
  }

  p_lock(moveLeft, moveTop, self, that) {
    //console.log(dragTop);
    const moduleId = self.attr('id');
    //竖向锁定了
    if (Store.state.align.lock.vertical_lock) {


      let module_Top = parseFloat(self.css('top')); //拖拽元素当前的位置
      let module_offset_Top = self.offset().top; //拖拽元素距离文档顶部的距离
      //插入锁定标签
      if ($('.lock_Top_style').length == 0) {
        var lock_Top_style = $(`<style class="lock_Top_style">#${moduleId} {top:${module_Top}px !important;}</style>`);
        lock_Top_style.appendTo('head');
      }
      if (moveTop < module_offset_Top - Store.state.align.Error_lock || moveTop > module_offset_Top + Store.state.align
        .Error_lock) {
        Store.commit('align/lock_vertical_false');
        //that.lock.vertical_lock = false;
        this.p_remove_line();
        this.p_remove_lock();
      }
    }

    //横向锁定了
    if (Store.state.align.lock.transverse_lock) {
      //console.log(123);
      let module_Left = parseFloat(self.css('left')); //拖拽元素当前的位置
      let module_offset_Left = self.offset().left; //拖拽元素距离文档顶部的距离
      //插入锁定标签
      if ($('.lock_Left_style').length == 0) {
        var lock_Left_style = $(
          `<style class="lock_Left_style">#${moduleId} {left:${module_Left}px !important;}</style>`);
        lock_Left_style.appendTo('head');
      }
      if (moveLeft < module_offset_Left - Store.state.align.Error_lock || moveLeft > module_offset_Left + Store.state
        .align.Error_lock) {
        Store.commit('lock_transverse_false');
        //that.lock.transverse_lock = false;
        this.p_remove_line();
        this.p_remove_lock();
      }
    }
  }

  //删除锁定元素
  p_remove_lock() {
    if ($('.lock_Top_style').length > 0) {
      $('.lock_Top_style').remove();
    }

    if ($('.lock_Left_style').length > 0) {
      $('.lock_Left_style').remove();
    }
  }

  /*
   * 对齐线，放到正在拖拽里的
   * */
  aline_drag(that, $this, dragLeft, dragTop, dragWidth, dragHeight) {
    //移动开始前，先清除线
    this.p_remove_line();
    //console.log(dragLeft,dragTop);
    const lines = Store.state.align.targetDom;
    for (var i = 0; i < lines.length; i++) {
      var target_left = lines[i].left;
      var target_top = lines[i].top;
      var target_width = lines[i].width;
      var target_height = lines[i].height;

      //横幅里面的有挂件，存进去就会是负数
      if (target_left < 0) {
        continue;
      }


      //10种可能的对齐线
      //拖拽元素的左边，与目标元素的左边一致,就只有一根线
      if (dragLeft > target_left - Store.state.align.Error_amount && dragLeft < target_left + Store.state.align.Error_amount) {
        Store.commit('align/lock_transverse_true');
        //that.lock.transverse_lock = true; //横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft);
      }
      //拖拽元素的左边，与目标元素的右边一致,就只有一根线
      if (dragLeft > target_left + target_width - Store.state.align.Error_amount && dragLeft < target_left +
        target_width + Store.state.align.Error_amount) {
        // console.log(target_top, target_height, dragTop, dragHeight, target_left)
        Store.commit('align/lock_transverse_true');
        //that.lock.transverse_lock = true; //横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft);
      }
      //中间的竖向对齐线
      if (dragLeft + (dragWidth / 2) > target_left + (target_width / 2) - Store.state.align.Error_amount && dragLeft +
        (dragWidth / 2) < target_left + (target_width / 2) + Store.state.align.Error_amount) {
        Store.commit('align/lock_transverse_true');
        //that.lock.transverse_lock = true; //横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft + (dragWidth / 2));
      }
      //拖拽元素的右边，与目标元素的右边一致,就只有一根线
      if (dragLeft + dragWidth > target_left + target_width - Store.state.align.Error_amount && dragLeft + dragWidth <
        target_left + target_width + Store.state.align.Error_amount) {
        Store.commit('align/lock_transverse_true');
        //that.lock.transverse_lock = true; //横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft + dragWidth);
      }
      //拖拽元素的右边，与目标元素的左边一致,就只有一根线
      if (dragLeft + dragWidth > target_left - Store.state.align.Error_amount && dragLeft + dragWidth < target_left +
        Store.state.align.Error_amount) {
        Store.commit('align/lock_transverse_true');
        //that.lock.transverse_lock = true; //横向锁定
        this.left_right_line(target_top, target_height, dragTop, dragHeight, dragLeft + dragWidth);
      }


      //拖拽元素的上边，与目标元素的上边一致,就只有一根线
      if (dragTop > target_top - Store.state.align.Error_amount && dragTop < target_top + Store.state.align.Error_amount) {
        Store.commit('align/lock_vertical_true');
        //that.lock.vertical_lock = true; //竖向锁定
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop);
      }
      //拖拽元素的上边，与目标元素的下边一致,就只有一根线
      if (dragTop > target_top + target_height - Store.state.align.Error_amount && dragTop < target_top +
        target_height + Store.state.align.Error_amount) {
        Store.commit('align/lock_vertical_true');
        //that.lock.vertical_lock = true; //竖向锁定
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop);
      }
      //中间的竖向对齐线
      if (dragTop + (dragHeight / 2) > target_top + (target_height / 2) - Store.state.align.Error_amount && dragTop +
        (dragHeight / 2) < target_top + (target_height / 2) + Store.state.align.Error_amount) {
        Store.commit('align/lock_vertical_true');
        //that.lock.vertical_lock = true; //竖向锁定
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop + (dragHeight / 2));
      }

      //拖拽元素的下边，与目标元素的下边一致,就只有一根线
      if (dragTop + dragHeight > target_top + target_height - Store.state.align.Error_amount && dragTop + dragHeight <
        target_top + target_height + Store.state.align.Error_amount) {
        //that.lock.vertical_lock = true; //竖向锁定
        Store.commit('align/lock_vertical_true');
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop + dragHeight);
      }

      //拖拽元素的下边，与目标元素的上边一致,就只有一根线
      if (dragTop + dragHeight > target_top - Store.state.align.Error_amount && dragTop + dragHeight < target_top +
        Store.state.align.Error_amount) {
        Store.commit('align/lock_vertical_true');
        //that.lock.vertical_lock = true; //竖向锁定
        this.top_bottm_line(dragLeft, dragWidth, target_left, target_width, dragTop + dragHeight);
      }
    }


  }

  //row滚动到适合的位置
  row_scroll(id) {
    const offsetTop = $(`#u${id}`).offset().top;
    const dom_height = $(`#u${id}`).height();
    const top = ($(window).height() - dom_height) / 2;


    //停止到画面中间
    $('html,body').animate({
      scrollTop: `${offsetTop - top}px`
    }, 200);
  }


  //创建横幅
  created_full_screen_banner() {
    const types = ['pc', 'mb'];

    for (let i = 0; i < types.length; i++) {

      Store.state.myRender.full_screen_banner.push(this.created_full_screen_banner_row(types[i], 'private'));
      Store.state.myRender.common.full_screen_banner.push(this.created_full_screen_banner_row(types[i], 'share'));
    }

  }

  created_full_screen_banner_row(type, banner_type) {
    const rowType = 'full_screen_banner';
    const imgs = full_screen_banner;

    Store.commit('app/ADD_widgets_id');
    let row = new Row({
      name: 'full_screen_banner',
      widgets_id: Store.state.app.widgets_id,
      rowType,
    });
    row.data.type = type;
    row.data.banner_type = banner_type; //表示是私有还是共享

    //初始化生成轮播图模式的3列
    for (let j = 0; j < imgs.length; j++) {
      const banner_obj = imgs[j];
      row.children.push(this.create_banner_col(row.widgets_id, 'banner', banner_obj));
    }

    //生成一个video用的col
    row.children.push(this.create_banner_col(row.widgets_id, 'video'));
    return row;
  }

  create_banner_col(pid, type, banner_obj = {}, rowType = 'full_screen_banner') {
    Store.commit('app/ADD_widgets_id');
    const col = new Col({
      widgets_id: Store.state.app.widgets_id,
      rowType,
      pid
    });
    col.data.full_screen_banner = banner_obj;
    col.data.full_screen_banner_pattern = type;
    return col;
  }


  add_banner_module(col_id, add_index, name, banner_id) {

    const find_obj = this.find_obj(col_id, ['full_screen_banner']);
    if (find_obj) {
      const col = find_obj.target;
      Store.commit('app/ADD_widgets_id');
      const new_module = new Module({
        name,
        pid: col_id,
        widgets_id: Store.state.app.widgets_id,
        rowType: col.rowType
      });
      new_module.data.banner_id = banner_id;
      col.children.splice(add_index, 0, new_module);

      //刷新swiper,跳转到当前页面
      /*Store.commit('full_screen_banner/set_isRender',false);
      this.p_$nextTick(()=>{
        Store.commit('full_screen_banner/set_isRender',true);
      })*/

    }


  }

  //百分数转化为小数
  toPoint(percent) {
    var str = percent.replace("%", "");
    str = str / 100;
    return str;
  }

  //小数转化为百分数
  toPercent(point) {
    var str = Number(point * 100).toFixed(1);
    str += "%";
    return str;
  }

  //横幅计算高度百分比
  banner_calculation_height_Percent(infor, h, type = 'is_set') {
    console.log('触发改变高度')
    //根据当前模式去计算高度百分比，默认下，最小高度百分比始终就是第一张的宽高比
    const radio_val = infor.banner_size.radio_val;
    const w_bfb = this.toPoint(infor.banner_size[radio_val].width); //宽度百分比
    const r = this.toPercent(h / (Store.state.app.screenWidth * w_bfb));
    infor.banner_size[radio_val].height = r;
    if (type == 'is_set') {
      infor.end_set_height = r;
    }

    //console.log('改变高度百分比',infor.banner_size[radio_val].height);
  }

  //横幅计算最小高度值
  //通过屏幕宽度或高度百分比或高度百分比计算出最小高度
  banner_calculation_minHeight(infor, type = 'min') {
    const radio_val = infor.banner_size.radio_val;
    //高度百分比
    //const h_bfb = this.toPoint(infor.banner_size[radio_val].height);
    let h_bfb = 0
    if (type === 'min') {
      h_bfb = this.toPoint(infor.end_set_height);
    } else {
      h_bfb = this.toPoint(infor.banner_size[radio_val].height);
    }

    //宽度百分比
    const w_bfb = this.toPoint(infor.banner_size[radio_val].width);
    //console.log('改变最小高度');
    let minHeight = Math.ceil(h_bfb * (Store.state.app.screenWidth * w_bfb));
    return minHeight

  }


  //横幅重新渲染
  full_banner_render() {
    Store.commit('full_screen_banner/set_isRender', false);
    this.p_$nextTick(() => {
      Store.commit('full_screen_banner/set_isRender', true);
    })
  }

  // 驼峰转下划线
  humpTurnUnderline(str) {
    return str.replace(/\B([A-Z])/g, '_$1').toLowerCase()
  }

  //横幅视频计算最小高度
  video_calculation_minHeight(infor) {
    const radio_val = infor.video_height.radio_val;
    const bfb = this.toPoint(infor.video_height[radio_val].height);
    return Math.round(bfb * Store.state.app.screenWidth);
  }

  copy_row_list(oldList, newList) {
    let rows = []
    for (let i = 0; i < oldList.length; i++) {
      const row = oldList[i];
      const new_row = this.copy_one_row(row);
      rows.push(new_row);
    }
    return rows;
  }

  copy_one_row(copy_row, type = 'default') {
    //复制前必须断开引用关系
    const row = JSON.parse(JSON.stringify(copy_row));
    delete row.data.anchor_id
    Store.commit('app/ADD_widgets_id');
    let new_row = new Row({
      name: row.name,
      widgets_id: Store.state.app.widgets_id,
      rowType: row.rowType,
      children: [],
      data: row.data,
      isNewRow: row.isNewRow,
      newType: row.newType,
      contentWidthType: row.data.pc_infor.contentWidthType,
      adaptBackgroundIsOpen: row.data.pc_infor.adaptBackgroundIsOpen,
      fixed_background_isOpen: row.data.pc_infor.fixed_background_isOpen
    });
    //默认状态下，会重置通栏与public_rows通栏关联id
    if (type == 'default') {
      //复制出来的通栏要生成一个新的关联id，以免和copy_row有关系
      new_row.data.public_rows_id = gen_id();
    }

    let children = [];
    if (row.children && row.children instanceof Array) {
      children = this.copy_col(row, new_row);
    }
    new_row.data.col_order_array = children.map(item => item.data.col_id)
    new_row.children = children;

    return new_row;
  }


  copy_module(col, new_col) {
    let modules = [];
    for (let i = 0; i < col.children.length; i++) {
      const module = col.children[i];
      delete module.data.anchor_id
      Store.commit('app/ADD_widgets_id');
      let new_module = new Module({
        widgets_id: Store.state.app.widgets_id,
        rowType: col.rowType,
        pid: new_col.widgets_id,
        data: module.data,
        name: module.name
      });

      if (module.children) {
        new_module.children = this.copy_col(module, module)
      }
      modules.push(new_module);
    }

    return modules;


  }

  copy_one_module(copy_module) {
    const module = JSON.parse(JSON.stringify(copy_module));
    delete module.data.anchor_id
    Store.commit('app/ADD_widgets_id');
    let new_module = new Module({
      widgets_id: Store.state.app.widgets_id,
      rowType: module.rowType,
      pid: module.pid,
      data: module.data,
      name: module.name
    });
    if (module.children) {
      new_module.children = this.copy_col(module, module)
    }
    return new_module;
  }


  //module重新绑定拖拽和缩放

  module_again_drag(parent_dom) {
    const doms = parent_dom.find('.module');
    for (let i = 0; i < doms.length; i++) {
      const widgets_id = doms.eq(i).attr('data-id');
      this.module_top_btn(widgets_id);
      this.module_left_btn(widgets_id);
      this.module_size_btn(widgets_id);
    }
  }

  //分离pc横幅和mb横幅
  find_banner() {

    //横幅的类型，是共享，还是私有
    const banner_type = Store.state.myRender.private.banner_type;

    //横幅集合
    let banners = banner_type === 'private' ? Store.state.myRender.full_screen_banner : Store.state.myRender.common.full_screen_banner;

    //从集合中取出pc或移mb
    let pc_banner, mb_banner;
    banners.map((item) => {
      if (item.data.type === 'pc') {
        pc_banner = item;
      } else {
        mb_banner = item;
      }
    })

    return {
      pc_banner,
      mb_banner
    };
  }

  reset_header_set_data() {
    const header_layout_row_setting = Store.state.myRender.common.header_layout_row_setting
    const scrollType = Store.state.app.scrollType
    const now_page = Store.state.app.now_page
    const xuanfu_position = Store.state.myRender.common.xuanfu_position
    setTimeout(() => {
      if(scrollType == 'normal') {
        if (header_layout_row_setting !== 'zhanwei' && (now_page == 'index' || xuanfu_position == 'station')) {
          $('.myheader-contain').addClass('header-xuanfu-new')
          $('.full_screen_banner .edit_tool_banner').css({
            top: $('.myheader').height()
          })
        } else {
          $('.myheader-contain').removeClass('header-xuanfu-new')
          $('.full_screen_banner .edit_tool_banner').css({
            top: 0
          })
        }
      }
    },500)

  }

  //顶部固定
  fixed_header() {
    const common = Store.state.myRender.common;
    const scroll_top = $(window).scrollTop();
    const header_top = Store.state.row.fixed.top;
    const fixed_dom = common.fixed_height === 'all' ? $('.layout_header') : $('.layout_header').find('.system_row');
    const ele_height = fixed_dom.height();
    if (common.fixed_header === 'true') {
      this.create_rowFixedNext(fixed_dom);
      if (scroll_top + 72 > header_top) {
        fixed_dom.addClass('layout_header_fixed');
        if(Store.state.app.topBarVisible){
          fixed_dom.css({
            top: Store.state.app.topBarHeight + 'px'
          })
        }else {
          fixed_dom.css({
            top: 0
          })
        }

        //如果高度不对，则重新赋值
        if ($('.rowFixedNext').length > 0) {
          $('.rowFixedNext').css('height', ele_height + 'px');
        }
        Store.state.row.fixed.fixeding = true;

      } else {
        // 没有滚动的状态
        fixed_dom.removeClass('layout_header_fixed');
        fixed_dom.css({
          top: 0
        })
        if ($('.rowFixedNext').length > 0) {
          $('.rowFixedNext').css('height', 0);
        }
        Store.state.row.fixed.fixeding = false;
      }
    }
  }


  //顶部固定数据初始化
  fixed_init() {

    this.fixed_reset();
    if (Store.state.app.view_pattern == 'mb') {
      return
    }
    const common = Store.state.myRender.common;
    //const next_dom = $('.rowFixedNext');
    const fixed_dom = common.fixed_height === 'all' ? $('.layout_header') : $('.layout_header').find('.system_row');

    if (fixed_dom.length <= 0) {
      return;
    }
    $('.layout_header').find('.system_row').css({
      top: 0
    })
    $('.layout_header').css({
        top: 0
    })
    if (common.fixed_header === 'true') {
      //记录原始位置
      Store.state.row.fixed.top = fixed_dom.offset().top;

      // if (next_dom.length == 0) {
      //   //创建一个垫高元素
      //   if (common.fixed_height === 'all') {
      //     fixed_dom.after('<div class="rowFixedNext"></div>');
      //   } else if (common.fixed_height === 'system') {
      //     fixed_dom.after('<div class="rowFixedNext"></div>');
      //   }
      // }
      this.create_rowFixedNext(fixed_dom);
    } else {
      $('.rowFixedNext').remove();
      fixed_dom.removeClass('layout_header_fixed');
    }

  }

  //创建垫高元素
  create_rowFixedNext(fixed_dom) {
    const next_dom = $('.rowFixedNext');
    if (next_dom.length == 0) {
      //创建一个垫高元素
      // if (common.fixed_height === 'all') {
      //   fixed_dom.after('<div class="rowFixedNext"></div>');
      // } else if (common.fixed_height === 'system') {
      //   fixed_dom.after('<div class="rowFixedNext"></div>');
      // }
      fixed_dom.after('<div class="rowFixedNext"></div>');
    }


  }

  //顶部固定重置
  fixed_reset() {
    $('.layout_header').removeClass('layout_header_fixed');
    $('.layout_header').find('.system_row').removeClass('layout_header_fixed');
    $('.rowFixedNext').remove();
  }

  //获取域名
  get_host() {
    const now_page = Store.state.app.now_page;
    const module = find_page(now_page, Store.state.app.pages).module;
    const prewId = router.history.current.query.id || router.history.current.query.typeId;

    get_host({
      module,
      prewId
    }).then((e) => {
      if (e.code == 200 && e.data) {
        if (now_page == 'search') {
          //自己拼接
          const search_words = router.history.current.query.searchWords;
          const widgets_id = router.history.current.query.widgets_id;
          const str = e.data.replace('.html', '-0-1-');
          const path = str + search_words + '?wid=' + widgets_id;
          Store.commit('preview/SET_path', path);
        } else {
          Store.commit('preview/SET_path', e.data);
        }


      } else {
        Message.error(i18n.t('base_row_y _ 副本_1932'));
        Store.commit('preview/SET_path', '');
      }

      // 获取臻信通开关
      // this.zxt_toggle()

    }).catch((err) => {
      console.error(err)
      Message.error(i18n.t('base_row_y _ 副本_1932'));
      Store.commit('preview/SET_path', '');
    })
  }

  //获取页面列表
  get_pags() {
    /*get_pags().then((e)=>{
      if(e.code == 200 && e.data && e.data instanceof Array){
        Store.commit('app/set_pages',e.data);
      }
    })*/
  }

  //手机状态下，眼睛按钮是否显示
  mb_eye_isShow() {
    let r = false;
    const body = Store.state.myRender.body;
    const footer = Store.state.myRender.footer;
    for (let i = 0; i < body.length; i++) {
      if (body[i].data.mb_infor.isShow == false) {
        r = true;
        break
      }
    }
    if (!r) {
      for (let i = 0; i < footer.length; i++) {
        if (footer[i].data.mb_infor.isShow == false) {
          r = true;
          break
        }
      }
    }
    Store.commit('mb_row_isShow/SET_eye_btn_isShow', r);

    if (r == false) {
      Store.commit('mb_row_isShow/SET_isShow', r);
    }
  }

  //关闭编辑弹框，并重置所有编辑逻辑
  main_dialog_reset() {
    Store.commit('main_dialog/Change_main_dialog_isShow', false);
    Store.commit("app/SET_edit_column", null);
    Store.commit('app/SET_module_Data', null); //当前编辑对象滞空
    Store.commit('main_dialog/Change_edit_name', ''); //当前编辑对象滞空
  }

  get_home() {
    get_home().then((e) => {
      if (e.code == 200 && e.data && e.data.role) {
        Store.commit('app/set_role', e.data.role);
        Store.commit('app/set_language', e.data.language);
        Store.commit('app/set_language_main', e.data.language_main);
        Store.commit('app/set_road_type', e.data.road_type);
        Store.commit('app/set_is_inline', e.data.firstUrl == '' ? false : true);
        if (e.data.firstUrl != '') {
          // 外贸不需要查询备案
          // getIcpInfo().then((res) => {
          //   if (res.code == 200 && res.data && res.data.value) {
          //     Store.commit('app/set_icp_info', res.data.value);
          //   }
          // })
        }
      }
    })
  }

  //全局颜色扫描所有挂件
  global_color_for_module() {
    const type = ['header', 'body', 'footer'];
    for (let i = 0; i < type.length; i++) {
      this.global_color_for_module_make(type[i]);
    }
  }

  //扫描逻辑
  global_color_for_module_make(type) {
    let list = [];
    if (typeof type === 'string') {
      list = Store.state.myRender[type];
    } else {
      list = type

    }

    //header或body或footer里的数据
    list.map((row, row_i) => {

      //遍历每一个挂件
      if (row.children && row.children instanceof Array) {
        row.children.map((col, module_i) => {
          //如果row也要受全局颜色影响，在这里加递归方法。
          if (col.children && col.children instanceof Array) {
            //如果col也要受全局颜色影响，在这里加递归方法。
            col.children.map((module, module_i) => {
              //全局颜色分为样式直接覆盖，和字段埋点两种类型
              if (complex_style[module.name]) {

                this.complex_style_cover(module);

                //名单里的配置挂件，搜索是有标题的，需要扫埋点
                if (module.name === 'basic_searchs') {
                  this.ergodic_module_attr(module.data, 'data')
                }
              } else {

                //递归module下面所有属性值
                this.ergodic_module_attr(module.data, 'data')
              }
            })
          }
        })
      }

    })

  }

  scanFontEachWidget() {
    const type = ['header', 'body', 'footer'];
    for (let i = 0; i < type.length; i++) {
      this.font_for_module_make(type[i]);
    }
  }

  getPageFontData(data) {
    let resultData = {
      header: new Set(),
      body: new Set(),
      footer: new Set(),
      fontList: new Set()
    }
    const typeList = ['header', 'body', 'footer'];
    const fontFamilySystemZhValue = store.state.options.fontFamilySystemZh.map(item => item.value);
    typeList.forEach((type) => {
      let list = Store.state.myRender[type];
      //header或body或footer里的数据
      list.forEach((row) => {
        //遍历每一个挂件
        if (row.children && Array.isArray(row.children)) {
          row.children.map((col) => {
            if (col.children && Array.isArray(col.children)) {
              col.children.map((module) => {
                if (col.isNewCol && col.newType === 'col1') {
                  (col.children || []).forEach(row_2 => {
                    (row_2.children || []).forEach(col_2 => {
                      (col_2.children || []).forEach(m => {
                        handleModule(m, type)
                      })
                    })
                  })
                } else {
                  handleModule(module, type)
                  if (module.name === 'basic_row_tab') {
                    (module.children || []).forEach(tab => {
                      (tab.children || []).forEach(m => {
                        handleModule(m, type)
                      })
                    })
                  }
                }
              })
            }
          })
        }
      })
    })

    function handleModule(module, type) {
      if (module.data.pc_widgets_infor.customFont && module.data.pc_widgets_infor.customFont.name) {
        resultData[type].add(module.data.pc_widgets_infor.customFont.name)
      }
      if (module.name === 'basic_text_rich_type') {
        let fontStrList = (module.data.listArr.title || '').match(/font-family:\s*fontface?(.*?);/g) || []
        fontStrList.forEach(item => {
          item = item.replace('font-family:', '')
          item = item.replace(';', '')
          item = item.trim()
          resultData[type].add(item)
        })
      }else{
        if (font_family_position[module.name] && font_family_position[module.name].length>0){
          let setting = font_family_position[module.name];
          let fontValue = '';
          if (setting && setting.length>0){
            setting.forEach(item => {
              let position = item.split('.');
              if(position.length==2){
                fontValue = module.data[position[0]][position[1]];
              } else if (position.length == 3){                
                fontValue = module.data[position[0]][position[1]][position[2]];
              }else{
                console.error(i18n.t('base_row_y_1944'));
              }
              // 去除中文字体
              if (fontValue[fontValue['radio_val']] && fontFamilySystemZhValue.indexOf(fontValue[fontValue['radio_val']]['fontFamily']) === -1) {
                resultData['fontList'].add(fontValue[fontValue['radio_val']]['fontFamily'])
              }  
            })
          }
        }
      }
    }
    return resultData
  }


  //切换样式
  complex_style_cover(module) {
    const styles = complex_style[module.name]();
    let baseData = module.data.pc_widgets_infor;
    const styleType = baseData.styleType;
    for (let i = 0; i < styles.length; i++) {

      if (styles[i].data.styleType == styleType) {
        this.changeTypeStyle(styles[i], baseData);
        break;
      }
    }
  }

  changeTypeStyle(item, baseData, type=false) {// 这个个地方多传递了一个参数是因为这个东西在切换按钮的时候 东西是需要重新赋值的呀
    for (let index in baseData) {
      //如果属性是个对象，则赋值默认值
      if (baseData[index] && typeof baseData[index] === 'object' && typeof baseData[index].default != 'undefined' && typeof item.data[index] != 'undefined' && typeof item.data[index].default != 'undefined') {
        //baseData[index].default = item.data[index].default;
        baseData[index].default = Object.assign({}, baseData[index].default, item.data[index].default)

        // if(baseData[index].radio_val == 'default' || type)baseData[index].custom = Object.assign({}, baseData[index].default)
        if(type)baseData[index].custom = Object.assign({}, baseData[index].default)
      }
      //如果不是对象，则原样赋值
      if (typeof baseData[index] != 'object' && item.data[index]) {
        baseData[index] = item.data[index]
      }
    }
    baseData.styleType = item.data.styleType;
  }


  //递归挂件所有属性
  ergodic_module_attr(data, key_name) {

    for (var i in data) {
      if (data[i] instanceof Object) {
        this.ergodic_module_attr(data[i], i)
      } else {

        //全局颜色绑定了值，那就把匹配的颜色替换掉_globalColor
        if (i.indexOf('_globalColor') > -1 && i != '' && key_name == 'default') {
          //找到那个和全局颜色匹配的颜色属性
          //const attr = i.replace('_globalColor','');
          data[i] = Store.state.myRender.common.theme_color;
          //绑定全局变量的key
          /*const key = data[i];
          if(global[key] && data[attr] != global[key]){
            data[attr] = global[key]
          }*/
        }
      }
    }
  }

  //光标选中
  set_focus(widgets_id) {
    let el = document.querySelector('#u' + widgets_id + ' .edit-div')
    el.focus();
    if ($.support.msie) {
      var range = document.selection.createRange();
      this.last = range;
      range.moveToElementText(el);
      range.select();
      document.selection.empty(); //取消选中
    } else {
      var range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  //所有页面锚点数据载入
  get_anchorAll(anchor_id) {
    let that = this
    get_anchor()
      .then(res => {
        if (res.code === 200) {
          let anchor_data = res.data
          let navID = ''
          for (let i in anchor_data) {
            if (Array.isArray(anchor_data[i])) {
              anchor_data[i] = anchor_data[i].filter(e => {
                if (e.id === anchor_id && e.navID) {
                  navID = e.navID
                }
                return e.id !== anchor_id
              })
            }
          }
          Store.commit('anchor/SET_allAnchorList', anchor_data);
          if (navID) {
            that.deleteNav(parseInt(navID), that.save_anchorAll())
          } else {
            that.save_anchorAll()
          }
        } else {
          this.showMessage(res)
        }
      })
      .catch(error => {
        this.p_$message.error(error)
      });
  }

  //当前页面锚点数据载入
  get_anchor(pageName) {
    let data = {
      page: pageName
    };
    get_anchor(data)
      .then(res => {
        if (res.code === 200) {
          // if (!Array.isArray(res.data)) {
          //   res.data = [];
          // }
          Store.commit('anchor/SET_anchorList', res.data);
        } else {
          this.showMessage(res)
        }
      })
      .catch(error => {
        this.p_$message.error(error)
      });
  }

  save_anchorAll() {
    let data = {
      anchor: Store.state.anchor.allAnchorList,
    }
    save_anchor(data)
      .then(res => {
        if (res.code == 200) {
          console.log('锚点数据保存成功')
          // that.p_save()
        }
      })
      .catch(error => {
        this.p_$message.error(error);
      });
  }

  save_anchor(anchorList) {
    let saveData = {
      page: Store.state.app.now_page,
      anchor: anchorList
    };
    let that = this
    save_anchor(saveData)
      .then(res => {
        if (res.code == 200) {
          console.log('锚点数据保存成功')
          that.p_save()
        }
      })
      .catch(error => {
        this.p_$message.error(error);
      });
  }

  //删除导航
  deleteNav(navID, fn) {
    let _Store = Store,
      that = this
    deleteNav({
      id: navID
    })
      .then(res => {
        if (res.code === 200) {
          // this.$message.success('删除导航成功');
          _Store.state.myRender.common.setting.headerNavRadio = false
          this.p_$nextTick(() => {
            _Store.state.myRender.common.setting.headerNavRadio = true
          })
          if (typeof fn === 'function') {
            that.p_save(fn)
          }
        } else {
          this.$message.error(res.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  del_module(widgets_id, module_index, anchor_id = '') {
    const obj = this.find_obj(widgets_id) ? this.find_obj(widgets_id).target : null;
    if (anchor_id) {
      let _Store = Store,
        that = this;
      this.p_$confirm(i18n.t('base_row_y _ 副本_1933'), i18n.t('view_public_topbar_23'), {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        type: 'warning'
      }).then(() => {
        that.get_anchorAll(anchor_id)
        if (obj) {
          obj.children.splice(module_index, 1);
        }
      }).catch(() => {
        that.p_$message({
          type: 'info',
          message: i18n.t('base_row_y _ 副本_1934')
        });
      });
    } else {
      if (obj) {
        let module = obj.children[module_index]
        if (module.name === "basic_nleavemessage") {
          delete Store.state.app.se_form_id[module.widgets_id]
        }
        obj.children.splice(module_index, 1);
      }
    }
  }

  set_link(link) {
    Store.commit('set_link/set_link_edit', link);
    Store.commit('set_link/set_link_dialog_show', true);
  }

  changeStyle(module, tabName = 'style') {
    const is_open = Store.state.main_dialog.main_dialog_isShow;
    if (is_open) {
      Store.commit('main_dialog/Change_main_dialog_isShow', false);
      this.p_$nextTick(() => {
        this.close_main_dialog(module, tabName);
      })
    } else {
      this.p_$nextTick(() => {
        this.close_main_dialog(module, tabName);
      })
    }

  }

  close_main_dialog(module, tabName) {
    Store.commit('app/SET_module_Data', module);
    Store.commit('main_dialog/Change_main_dialog_isShow', true);
    Store.commit('main_dialog/Change_edit_name', module.name);
    Store.commit('main_dialog/set_tabs_name', tabName)
  }

  autoplay_obj(banner_set, obj) {
    const type = banner_set.radio_val;
    let autoplay = {};
    if (type === 'default' || type === 'custom') {
      autoplay = {
        disableOnInteraction: false,
        delay: banner_set[type].delay * 1000,
      };
      obj.speed = banner_set[type].speed * 1000
    } else {
      autoplay = false;
    }
    return autoplay;
  }

  getSearchsParams() {
    getSearchsParams()
      .then(res => {
        if (res.code == 200) {
          Store.commit('searchs_params/SET_searchs_params_list', res.data);
        } else {
          this.showMessage(res)
        }
      })
      .catch(error => {
        this.p_$message.error(error);
      });
  }

  //轮播多图重新渲染
  all_banner_render(name) {
    Store.commit(`app/set_${name}_isRender`, false);
    this.p_$nextTick(() => {
      Store.commit(`app/set_${name}_isRender`, true);
    })
  }

  //图册图片过滤
  atlas_imgs_filter(imgs) {
    const list = imgs;
    list.map((item) => {
      item.summary = item.summary ? item.summary : '';
      item.intro = item.intro ? item.intro : link;
      item.album_id = item.album_id ? item.album_id : '';
      item.img_name = item.img_name ? item.img_name : '';
      item.img_type = 'atlas_data';
    })
    return list;
  }

  imgs_init(that_data, name) {
    const page = that_data.module.data.pc_widgets_infor.page;
    if (that_data.module.data.listArr.type === 'custom') {
      //判断分页是否开启
      if (page && page.radioValue && that_data.module.data.listArr.module_style == '0') {
        that_data.total = that_data.module.data.listArr.custom.length;
        that_data.imgs = this.pageShowList(that_data.module.data.listArr.custom, page, that_data.currentPage);
      } else {
        that_data.imgs = that_data.module.data.listArr.custom;
      }

    } else {
      this.get_atlas(that_data);
    }
  }

  // 图标组合初始化数据
  icons_init(that_data, name) {
    if (that_data.module.data.listArr.type === 'custom') {
      that_data.imgs = that_data.module.data.listArr.custom;
    } else {
      this.get_atlas(that_data);
    }
  }


  //传一个图册id，获取一个图册信息
  get_atlas(that_data) {
    const id = that_data.module.data.listArr.atlas_id;
    let page = that_data.module.data[Store.state.app.view_pattern + "_widgets_infor"].page;
    if (!page) {
      page = that_data.module.data.pc_widgets_infor.page;
    }
    if (id) {
      that_data.loading = true;
      editAtlasList({id}).then((e) => {

        that_data.imgs = [];
        if (e.code == 200 && e.data && e.data.lists && e.data.lists instanceof Array) {

          //判断分页是否开启
          if (page && page.radioValue && that_data.module.data.listArr.module_style == '0') {
            that_data.total = e.data.lists.length;
            const list = this.atlas_imgs_filter(e.data.lists);
            that_data.imgs = this.pageShowList(list, page, that_data.currentPage);
          } else {
            that_data.imgs = this.atlas_imgs_filter(e.data.lists);
          }
        }
      }).catch(() => {
        that_data.imgs = [];
      }).finally(() => {

        that_data.loading = false;
      })
    } else {
      //数据为空
      that_data.imgs = [];

    }
  }

  //各种列表，每条数据的name的key不叫name，就要往下传key
  content_list_filter(list, name_key = "name") {

    if (list instanceof Array) {
      list.map((item) => {
        item.name = item[name_key]
      })
    }

  }

  request_data_judge(arr) {
    const str_ids = arr.join(',');
    let ids = '';
    //判断是否要请求所有列表
    if (str_ids == '') {
      ids = '-1,0'
    } else {
      ids = str_ids
    }
    return ids;
  }

  //分页判断
  has_page(that_data) {
    let data = {
      disabled: 'false',
      status: 1
    }
    //判断是index还是edit
    if (that_data.module && that_data.module.data) {
      let page = that_data.module.data.pc_widgets_infor.page;

      if (that_data.listArr.module_style == '0' && page.radioValue) {
        //需要分页
        data.rows = page.pageSize;
        data.page = that_data.currentPage;
      } else {
        data.rows = 999999;
        data.page = 1;
      }
    }

    return data;

  }

  //根据类型确定参数
  atlas_request_data_filter(that_data, type = 'category_id') {
    //做分页判断
    const data = this.has_page(that_data);
    if (that_data.listArr.type === 'custom') {
      data.ids = this.request_data_judge(that_data.listArr.custom);
    } else {
      data[type] = this.request_data_judge(that_data.listArr.catalog_id);
    }
    return data;
  }

  atlas_catalog_get_atlas(that_data, type = 'index') {
    //that_data.list = [];
    that_data.loading = true;
    //请求图册列表，图册列表的参数需要重新判断，是传ids还是category_id
    get_atlas(this.atlas_request_data_filter(that_data))
      .then(e => {
        if (
          e.code == 200 &&
          e.data &&
          e.data.rows &&
          e.data.rows instanceof Array
        ) {
          that_data.total = e.data.total;
          //list是组件index.vue中渲染试图的变量
          //不同的分页，渲染方式不同

          if (type == 'index') {
            const page = that_data.module.data.pc_widgets_infor.page;
            if (page.radioValue && page.pageStyle == 2) {
              //展开更多，数据插入，不是数据重写
              e.data.rows.map((item) => {
                item.name = item.album_name;
                that_data.list.push(item);
              });
            } else {
              that_data.list = this.atlas_data_filter(e.data.rows);
            }

          } else {
            //这是在edit中调用的
            that_data.list = this.atlas_data_filter(e.data.rows);
            // that_data.$nextTick(()=>{
            //   if(that_data.img_height_init && typeof that_data.img_height_init == 'function'){
            //     that_data.img_height_init();
            //   }
            // })
          }
          //this.dirty_data_filter(that_data.listArr.custom,that_data.list);


          // 滚动模式
          if (that_data.listArr.module_style == '1' && that_data.horizontal_rolling) {
            that_data.$nextTick(() => {
              that_data.horizontal_rolling();
            })

          }
        }

      })
      .finally(() => {
        that_data.loading = false;
      });
  }

  atlas_data_filter(list) {
    return list.map((item) => {
      item.name = item.album_name;
      return item;
    });
  }


  main_dialog_blur(doms) {
    for (let i = 0; i < doms.length; i++) {
      doms[i].blur();
    }
  }

  create_class(list) {
    let end_arr = [];
    this.class_filter(list, end_arr);
    return end_arr;
  }

  class_filter(arr, end_arr) {
    for (let i = 0; i < arr.length; i++) {
      const obj = JSON.parse(JSON.stringify(arr[i]));
      delete obj.children;
      end_arr.push(obj);
      if (arr[i].children) {
        this.class_filter(arr[i].children, end_arr);
      }
    }
  }

  //横幅高度最终修改
  full_screen_banner_end() {
    try {
      const banner_infor = Store.state.full_screen_banner.full_screen_banner_infor;
      if (banner_infor) {
        this.dynamic_computation_height(banner_infor);
      }

    } catch (err) {
    }

  }

  //大保存
  p_save(fn) {
    if (Store.state.app.pageDataLoading) {
      return;
    }
    const validation = this.theme_id_validation();
    if (validation) {
      return
    }
    try {
      this.full_screen_banner_end()
    } catch (err) {
    }

    Store.commit('app/SET_save_loading', true);
    //设计师数据过滤
    if (Store.state.app.role === 'designer') {
      this.designer_filter_data();
    }
    // 计算图片的宽度
    if (Store.state.app.view_pattern === 'pc') {
      this.resetPictureWidth();
    }
    //系统列表以及详情页面挂件参数
    const params = this.getPageDesignParams('save')
    const data = {
      header: Store.state.myRender.header,
      body: Store.state.myRender.body,
      footer: Store.state.myRender.footer,
      full_screen_banner: Store.state.myRender.full_screen_banner,
      private: Store.state.myRender.private,
      common: Store.state.myRender.common,
      public_rows: Store.state.myRender.public_rows,
    };


    //console.log(JSON.stringify(data));

    p_save({
      page: router.history.current.name || Store.state.app.now_page,
      data,
      ...params
    }).then((e) => {
      if (e.code == 200) {
        this.p_$message.success({
          showClose: true,
          message: i18n.t('base_row_y _ 副本_1935')
        });
        Store.commit('app/set_operation', false);
        Store.commit('app/SET_is_change', false);
        let translate_language = Store.state.app.translate_language
        if (Store.state.app.role == 'customer' &&
          Store.state.app.language == Store.state.app.language_main && translate_language.length > 0) {
          let promiseArr = []
          translate_language.forEach(e => {
            promiseArr.push(this.translatePage({
              page: Store.state.app.now_page,
              language: [e],
              ifBanner: Store.state.app.isTranslateBanner,
              ...params
            }))
          })
          Promise.all(promiseArr).then(data => {
            if (data instanceof Array && data.length > 0) {
              const result = data.filter(e => e.code !== 200)
              console.log('语言翻译的结果：', result)
              if (result.length == 0) {
                this.p_$message.success(i18n.t('base_row_y _ 副本_1936'))
              }
            }
          })
        }
        //保存之后执行回调函数
        if (typeof fn === 'function') {
          fn();
        }
      } else {
        this.p_$message.error(i18n.t('base_row_y _ 副本_1937'));
      }
    }).finally(() => {
      //this.clearStatic();
      Store.commit('app/SET_save_loading', false);
    })
  }


  translatePage(sendData) {
    return new Promise((resolve, reject) => {
      translatePage(sendData).then(res => {
        if (res.code === 200) {
          resolve(res)
        } else {
          this.p_$message.warning({
            showClose: true,
            message: res.message
          });
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  //清理缓存
  clearStatic() {
    clearStatic().then((e) => {
      // if (e.code != 200) {
      //   this.p_$message.error('清理缓存失败！');
      // }
    }).catch(() => {
      //this.p_$message.error('清理缓存失败！');
    })
  }
  resetPictureWidth(all = ['header', 'body', 'footer', 'full_screen_banner']) {
    for (let i = 0; i < all.length; i++) {
      this.setPictureWidth(Store.state.myRender[all[i]]);
    }
  }
  setPictureWidth(rows) {
    const widgetsArr = Store.state.app.thumbnailWidgetsArr
    const widgetsObj = Store.state.app.thumbnailWidgetsObj
    for (let i = 0; i < rows.length; i++) {
      const cols = rows[i].children;
      for (let j = 0; j < cols.length; j++) {
        const modules = cols[j].children;
        for (let k = 0; k < modules.length; k++) {
          const name = modules[k].name
          const widgets_id = modules[k].widgets_id
          if (widgetsArr.indexOf(name) > -1) {
            const className = widgetsObj[name].className
            const parsentDom = $(`#u${widgets_id} ${className}`)
            if(parsentDom.length > 0) {
              const parent_w = parsentDom.eq(0).width()
              let img_w = null
              let imgDom = document.getElementById(`u${widgets_id}`).getElementsByTagName('img')
              if(imgDom.length > 0) {
                img_w = imgDom[0].naturalWidth
              }
              this.checkThumbnailWidth(modules[k].data.listArr,parent_w,img_w)
            }
          }
        }
      }
    }
  }

  //上传模板就是复制设计师的数据库，设计师保存，需要重新设置默认，让默认值等于自定义值
  designer_filter_data(all = ['header', 'body', 'footer', 'full_screen_banner', 'common', 'private']) {
    for (let i = 0; i < all.length; i++) {
      this.designer_filter_make(Store.state.myRender[all[i]]);
    }
  }

  designer_filter_make(data) {

    if (Array.isArray(data)) {
      //如果是数组
      for (let i = 0; i < data.length; i++) {
        this.designer_filter_make(data[i]);
      }

    } else if (data instanceof Object && data != null) {
      //如果不是数组，但是，是对象
      for (let i in data) {
        try {
          //如果是包含默认，自定义的对象
          if (data[i].radio_val || data[i].radioVal) {
            this.designer_data_handle(data[i]);
          }
          this.designer_filter_make(data[i]);
        } catch (err) {
        }

      }
    }
  }

  //默认数据处理
  designer_data_handle(obj) {
    //如果设计师选中的是自定义，那么要把默认覆盖掉
    if (obj.radio_val === 'custom' || obj.radioVal === 'custom') {
      obj.default = JSON.parse(JSON.stringify(obj.custom));
    }
  }

  //查看公共池，有则覆盖，无则插入
  //加入公共池流程
  look_public_rows(now_row) {
    const public_rows = Store.state.myRender.public_rows;
    let index = null;
    for (let i = 0; i < public_rows.length; i++) {
      if (public_rows[i].data.public_rows_id && public_rows[i].data.public_rows_id === now_row.data.public_rows_id) {
        index = i;
      }
    }

    //先要拷贝一个新的，重置掉所有row，col，module的id
    const new_obj = this.copy_one_row(now_row);

    if (index != null) {
      //找到了就覆盖
      public_rows[index] = new_obj;
    } else {
      //找不到就插入
      public_rows.push(new_obj)
    }
  }

  //不同页面，是否默认增加独有挂件的判断
  is_add_page_modules() {
    //用配置去判断，当前页面是否存在独有挂件
    if (page_module_config[Store.state.app.now_page]) {

      const body = Store.state.myRender.body;
      let is_have = false;

      for (let i = 0; i < body.length; i++) {
        if (body[i].data.body_system_row === 'true') {
          //已经存在了
          is_have = true;
          break;
        }
      }

      if (!is_have) {
        this.create_sys_row_sys_module();
      }

    }
  }

  dialog_close() {
    this.main_dialog_reset();
  }

  //通栏是否进入编辑状态
  row_is_edit(row) {
    let isEdit = false;
    const click_edit_row_btn = Store.state.row.click_edit_row_btn;
    if (click_edit_row_btn && click_edit_row_btn.widgets_id == row.widgets_id) {
      isEdit = true
    }
    return isEdit;
  }

  //当前编辑row，下取消拖拽排序
  edit_row_set_sort(r) {
    const row = Store.state.row.click_edit_row_btn;
    if (row) {
      const row_id = row.widgets_id;
      $(`#u${row_id}`).find('.sort_modules').sortable({disabled: r});
    }

  }

  //关闭row编辑
  row_edit_close() {
    // this.edit_row_set_sort(false);//当前编辑row，设置拖拽排序
    // Store.commit("row/SET_click_edit_row_btn", null);
    // Store.commit("row/SET_edit_mongolia", false);
    // Store.commit("row/SET_edit_mongolia_horizontal", false);
    // Store.commit("app/SET_module_Data", null);
    // -1为不是在线表单时候的遮罩关闭
    if (Store.state.app.se_item_index === -1) {
      this.edit_row_set_sort(false);//当前编辑row，设置拖拽排序
      Store.commit("row/SET_click_edit_row_btn", null);
      Store.commit("app/SET_module_Data", null);
    } else {
      this.dialog_close()
    }
    Store.commit("row/SET_edit_mongolia", false);
    Store.commit("row/SET_edit_mongolia_horizontal", false);
  }

  row_Mongolia_close() {
    $(".fixed_header_mongolia").css('display', 'none');
    $(".layout_header").removeClass('fixed_header_edit');
    this.row_edit_close();
  }

  is_jump(fn) {
    if (Store.state.app.is_change) {
      this.p_$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
        confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: "del_dialog",
        appendToBody: true
      })
        .then(() => {
          if (typeof fn === 'function') {
            fn();
          } else if (typeof fn === 'object' && fn.href) {
            if (fn.target === '_blank' || !fn.target) {
              window.open(fn.href)
            } else if (fn.target === '_self' || !fn.target) {
              window.location.href = fn.href
            }
          }
        })
        .catch((e) => {
          console.error(e)
        });
    } else {
      if (typeof fn === 'function') {
        fn();
      } else if (typeof fn === 'object' && fn.href && fn.target) {
        if (fn.target === '_blank') {
          window.open(fn.href)
        } else if (fn.target === '_self') {
          window.location.href = fn.href
        }
      }
    }
  }

  calculation_mongolia(row) {
    const id = row.widgets_id;
    const top = $(`#u${id}`).offset().top;
    const height = $(`#u${id}`).height();
    const body_height = $('body').height();
    $('.upper_mongolia').css({
      height: top + 'px'
    });

    $('.lower_mongolia').css({
      top: top + height + 'px',
      height: body_height - (top + height) + 'px'
    });
  }

  calculation_mongolia_horizontal(row) {
    const id = row.widgets_id
    const top = $(`#u${id}`).offset().top
    const left = $(`#u${id}`).offset().left
    const height = $(`#u${id}`).height()
    const width = $(`#u${id}`).width()
    const body_width = $('body').width()
    $('.left_mongolia').css({
      top: top + 'px',
      height: height + 'px',
      width: left + 'px'
    });
    console.log('left:', left)

    $('.right_mongolia').css({
      top: top + 'px',
      height: height + 'px',
      width: body_width - left - width + 'px'
    });
  }

  is_contextmenu(row) {
    let r = true;

    if (row.rowType == "body") {
      return true;
    } else {
      return !this.has_system_module(row);
    }
  }

  has_system_module(row) {
    let r = false;
    const cols = row.children;
    for (let j = 0; j < cols.length; j++) {
      const modules = cols[j].children;
      for (let k = 0; k < modules.length; k++) {
        if (
          modules[k].name === "basic_webtitle" ||
          modules[k].name === "basic_navbar" ||
          modules[k].name === "basic_copyright" ||
          (modules[k].data && (modules[k].data.isSystem == 'true' || modules[k].data.is_system == 'true'))
        ) {
          r = true;
          break;
        }
      }
    }
    return r;
  }

  contextmenu_position(e) {
    const h = $(".fk-projectContextMenu").height() + 10;
    const w = $(".fk-projectContextMenu").width() + 10;
    const box_h = $(window).height();
    const box_w = $(window).width();
    let x = e.clientX;
    let y = e.pageY;
    if (box_h - e.clientY <= h) {
      y = e.pageY - h;
    }

    if (box_w - e.clientX <= w) {
      x = e.clientX - w;
    }
    return {x, y}
  }

  use_name_find_module(rowType, name) {
    const rows = Store.state.myRender[rowType];
    let r = null;
    for (let i = 0; i < rows.length; i++) {
      const cols = rows[i].children;
      for (let j = 0; j < cols.length; j++) {
        const modules = cols[j].children;
        for (let k = 0; k < modules.length; k++) {
          if (modules[k].name == name) {
            r = modules[k];
            break;
          }
        }
      }
    }
    return r;

  }

  watch_has_title_nav() {
    this.title_nav_isShow('basic_navbar');
    this.title_nav_isShow('basic_webtitle');
  }

  title_nav_isShow(name) {
    //检查顶部是否存在导航或网站标题，没有则插入一个
    const module = this.use_name_find_module("header", name);
    //如果确实不存在
    if (module == null) {
      //找到顶部系统栏
      this.sys_auto_add(name);
    }
  }

  sys_auto_add(name, rowType = "header") {
    const rows = Store.state.myRender[rowType];
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].data.is_system == "true" && rows[i].children.length > 0) {
        //创建一个挂件
        Store.commit("app/ADD_widgets_id");
        const module = new Module({
          widgets_id: Store.state.app.widgets_id,
          rowType,
          pid: rows[i].widgets_id,
          name
        });
        module.data.isSystem = "true";
        const col = rows[i].children[0];
        if (col && col.children) {
          col.children.unshift(module);
        }
        break;
      }
    }
  }

  has_moadule_align(module) {
    const view_pattern = Store.state.app.view_pattern;
    const marginLeft = module.data[view_pattern + "_infor"].marginLeft;
    const marginRight = module.data[view_pattern + "_infor"].marginRight;
    if (parseFloat(marginLeft) == 0 && parseFloat(marginRight) == 0) {
      return false;
    } else {
      return true;
    }

  }

  //动态计算横幅高度
  dynamic_computation_height(infor) {
    //横幅能被里面挂件撑开，所以需要动态计算一次高度，重新复写值
    const h = $('.myBanner').height();
    this.banner_calculation_height_Percent(infor, h, 'no_set');

  }


  dirty_data_filter(ids, datas, key = 'id') {
    for (let i = 0; i < ids.length; i++) {
      let is_have = false;
      for (let j = 0; j < datas.length; j++) {
        if (ids[i] == datas[j][key]) {
          is_have = true;
          break;
        }
      }
      if (!is_have) {
        ids.splice(i, 1);
        i--
      }
    }
  }

  //模板id判断，如果cookie里的id和程序里的id不一致，说明是在后台切换了模板
  theme_id_validation() {
    const now_theme_id = Store.state.app.theme_id;
    const cookie_theme_id = Cookies.get('admin_theme_id_wm');

    const now_admin_token = Store.state.app.admin_token;
    const cookie_admin_token = Cookies.get('admin_token_wm');

    if (now_theme_id != cookie_theme_id || now_admin_token != cookie_admin_token) {
      Store.commit('app/SET_is_change', false);
      alert(i18n.t('base_row_y _ 副本_1938'));
      window.location.reload();
      return true;
    }
    return false;
  }

  implement_save() {
    //关闭一切弹窗
    this.row_edit_close();
    this.dialog_close();
    this.p_save();
    // 保存表单
    this.saveChangeForm()
  }

  implement_Revoke() {
    //关闭一切弹窗
    this.row_edit_close();
    this.dialog_close();
    this.main_dialog_reset();
    Store.commit("app/SET_is_change", true);
    Store.commit('app/set_is_add_history', false);
    if (indexedDB) {
      Store
        .dispatch("historical/find_sql", {
          $message: this.p_$message,
          type: "Revoke"
        })
        .finally(() => {
          this.p_$nextTick(() => {
            //this.templet.recount_fixed()
            this.fixed_header()
            Store.commit('app/set_is_add_history', true);
          });
        });
    } else {
      this.p_$message.error(i18n.t('base_row_y _ 副本_1939'));
    }
  }

  implement_Recovery() {
    //关闭一切弹窗
    this.row_edit_close();
    this.dialog_close();
    this.main_dialog_reset();
    Store.commit("app/SET_is_change", true);
    Store.commit('app/set_is_add_history', false);
    if (indexedDB) {
      Store
        .dispatch("historical/find_sql", {
          $message: this.p_$message,
          type: "Recovery"
        })
        .finally(() => {
          this.p_$nextTick(() => {
            //this.templet.recount_fixed()
            this.fixed_header()
            Store.commit('app/set_is_add_history', true);
          });
        });
    } else {
      this.p_$message.error(i18n.t('base_row_y _ 副本_1939'));
    }
  }

  mb_edit_show(e, that_data) {
    Store.commit("row/Reset_mb_edit");
    const l = $(window).width() / 2 + 375 / 2 + 10;
    let t = $(e.target).offset().top;
    if (t < 140) {
      t = 180;
    }
    Store.state.row.mb_edit.left = l;
    Store.state.row.mb_edit.top = t;
    Store.state.row.mb_edit.isShow = true;
    Store.state.row.mb_edit.select_row = that_data.row;
  }

  mb_edit_hidden() {
    if (Store.state.row.mb_edit.timer == null) {
      Store.state.row.mb_edit.timer = setTimeout(() => {
        Store.commit("row/Reset_mb_edit");
      }, 300);
    }
  }

  //拖拽module。处理上下
  draggable_start_Y(btn, module_id) {
    const module = btn.closest('.module');
    const module_margin_top = parseFloat(module.css('margin-top'));
    Store.state.module.module_marginTop = module_margin_top;
  }

  //拖拽module。处理左右
  draggable_start_X(module_id) {
    const find_obj = this.find_obj(module_id);
    if (find_obj) {
      const obj = find_obj.target;
      const view_pattern = Store.state.app.view_pattern;
      //只记录一次
      Store.state.module.module_marginLeft = parseFloat(obj.data[`${view_pattern}_infor`].marginLeft);
      Store.state.module.module_marginRight = parseFloat(obj.data[`${view_pattern}_infor`].marginRight);

    }
  }

  //拖拽module。drag处理上下
  draggable_drag_Y(btn, module_id, ui, type) {
    const modules_width = btn.parents('.layout_column').width();
    const now_top = parseFloat(btn.css('top'));
    const helper_top = ui.position.top;
    const end_num = helper_top - now_top + Store.state.module.module_marginTop;
    const val = end_num / modules_width * 100;
    if (val >= 0) {
      const r = val > Store.state.module.diff_val ? val : 0
      Store.state.module.drag_val.top = r;
      btn.closest('.module').css('margin-top', r + '%');
      this.left_top_margin_tips(btn, 'top', type);
    }
  }

  //拖拽module。drag处理左右
  draggable_drag_X(btn, module_id, ui, type) {
    const modules_width = btn.parents('.layout_column').width();
    const now_left = parseFloat(btn.css('left'));
    const helper_left = ui.position.left;
    const difference = (helper_left - now_left) / modules_width * 100; //百分比的差值
    const left_val = Store.state.module.module_marginLeft + difference;
    const right_val = Store.state.module.module_marginRight - difference;
    const diff_val = Store.state.module.diff_val;


    if (left_val >= 0 && right_val >= 0) {

      //补差计算
      let left_r = left_val;
      let right_r = right_val;
      if (left_val <= diff_val) {
        left_r = 0;
        right_r = right_val + left_val;
      }

      if (right_val <= diff_val) {
        right_r = 0;
        left_r = left_val + right_val;
      }
      Store.state.module.drag_val.left = left_r;
      Store.state.module.drag_val.right = right_r;
      btn.closest('.module').css('margin-left', left_r + '%');
      btn.closest('.module').css('margin-right', right_r + '%');
      this.left_top_margin_tips(btn, 'left', type);
    }
  }

  //拖拽module。end处理上下
  draggable_end_Y(find_obj, view_pattern) {
    if (find_obj && Store.state.module.drag_val.top != null) {
      const obj = find_obj.target;
      obj.data[`${view_pattern}_infor`].marginTop = Store.state.module.drag_val.top + '%';
      Store.state.module.drag_val.top = null;
    }
  }

  //拖拽module。end处理左右
  draggable_end_X(find_obj, view_pattern) {
    if (find_obj && Store.state.module.drag_val.left != null && Store.state.module.drag_val.right != null) {
      const obj = find_obj.target;
      obj.data[`${view_pattern}_infor`].marginLeft = Store.state.module.drag_val.left + '%';
      obj.data[`${view_pattern}_infor`].marginRight = Store.state.module.drag_val.right + '%';
      Store.state.module.drag_val.left = null;
      Store.state.module.drag_val.right = null;
    }

  }


  //任意拖拽
  module_draggable_icon_btn(module_id) {
    const that = this;

    $(`#u${module_id}`).children('.draggable_icon').draggable({
      helper: "clone",
      zIndex: -1,
      start() {
        //处理上下
        that.draggable_start_Y($(this), module_id);

        //处理左右
        that.draggable_start_X(module_id);

        //公共事件
        that.dialog_close();
        that.aline_start(that, $(`#u${module_id}`), '.module');
        $(this).addClass('change_margining')
      },
      drag(event, ui) {
        //处理上下
        that.draggable_drag_Y($(this), module_id, ui, 'left_top');

        //处理左右
        that.draggable_drag_X($(this), module_id, ui, 'left_top');

        that.use_aline_drag(module_id);

        //判断通栏是否在编辑状态
        that.change_resize_bottom($(this));

      },
      stop() {
        const view_pattern = Store.state.app.view_pattern;
        const find_obj = that.find_obj(module_id);
        that.p_remove_line();
        Store.commit('align/clear_targetDom');
        $('#one_style').remove();
        $(this).removeClass('change_margining')

        that.draggable_end_Y(find_obj, view_pattern);
        that.draggable_end_X(find_obj, view_pattern);

        $(this).parents('.layout_row').find('.column_operation_line').removeClass('column_operation_line_show')
        $(this).parents('.module').removeClass('moving')
      }

    })

  }

  //底部服务栏添加
  footnav_isShow(name, rowType = "footer") {
    //检查底部是否存在底部服务栏，没有则插入一个
    const module = this.use_name_find_module(rowType, name);
    //如果确实不存在
    if (module == null) {
      this.create_footnav(name, rowType);
    }
  }

  delete_footnav() {
    let len = Store.state.myRender.footer.length
    Store.state.myRender.footer.splice(len - 1, 1)
  }

  initLinkData(nav_list, languageType) {
    const initData = {
      0: {
        link: {
          display_name: i18n.t('router_default_70'),
          id: 1,
          link: "/",
          module: "index:index",
          name: i18n.t('router_default_70'),
          routerPath: "index"
        },
        img: 'iconshouye3'
      },
      1: {
        link: {
          display_name: "About us",
          id: 2,
          link: "/p-about.html",
          module: "p:about",
          name: "About us",
          routerPath: "about"
        },
        img: 'iconguanyuwomen2'
      },
      2: {
        link: {
          display_name: "Service cases",
          id: 6,
          link: "/case.html",
          module: "case:index",
          name: "Service cases",
          routerPath: "case_index"
        },
        img: 'iconchanpin'
      },
      3: {
        link: {
          display_name: "News center",
          id: 9,
          link: "/article.html",
          module: "article:index",
          name: "News center",
          routerPath: "article_index"
        },
        img: 'icontubiaozhizuomoban'
      },
      4: {
        link: {
          display_name: "Contact us",
          id: 15,
          link: "/p-contact.html",
          module: "p:contact",
          name: "Contact us",
          routerPath: "contact"
        },
        img: 'iconlianxiwomen8'
      }
    }
    nav_list.forEach((item, index) => {
      item.intro.inside_link.section.value = initData[index].link
      item.intro.select_val_preview = initData[index].link.display_name
      item.img = initData[index].img
    })
    return nav_list
  }

  // 创建底部服务栏
  create_footnav(name, rowType = "footer") {
    //创建一个row
    Store.commit('app/ADD_widgets_id');
    const row = new Row({
      widgets_id: Store.state.app.widgets_id,
      rowType
    });
    // 设置row的名称
    row.name_ = row.name + '__' + name
    Store.commit('app/ADD_widgets_id');
    const col = new Col({
      widgets_id: Store.state.app.widgets_id,
      rowType,
      pid: row.widgets_id
    });
    col.data.pc_infor.col = 12;

    //创建挂件
    Store.commit('app/ADD_widgets_id');
    const module = new Module({
      widgets_id: Store.state.app.widgets_id,
      rowType,
      pid: col.widgets_id,
      name
    });
    module.data.isSystem = "true";
    module.data.listArr.style_color = Store.state.myRender.common.theme_color
    module.data.listArr.nav_list = this.initLinkData(module.data.listArr.nav_list, Store.state.app.language)
    col.children.push(module);
    row.children.push(col);
    Store.state.myRender[rowType].push(row);
  }

  //多语言导航添加
  multi_language_isShow(name, rowType = "header") {
    let module_data = null
    let module_rowType = 'header'
    if (rowType === 'header') {
      module_rowType = 'footer'
      module_data = this.use_name_find_module(module_rowType, name);
    } else {
      module_data = this.use_name_find_module(module_rowType, name);
    }
    //检查顶部是否存在多语言导航，没有则插入一个
    const module = this.use_name_find_module(rowType, name);
    //如果确实不存在
    if (module == null) {
      //找到顶部系统栏
      this.create_langs(name, rowType, module_rowType, module_data);
    }
  }

  zh_language_isShow(name, rowType = "header") {
    //检查顶部是否存在中文语言设置，没有则插入一个
    const module = this.use_name_find_module(rowType, name);
    //如果确实不存在
    if (module == null) {
      //找到顶部系统栏
      let col = Store.state.myRender.header[0].children[0]
      Store.commit('app/ADD_widgets_id')
      let module_data = new Module({
        name: name,
        pid: col.pid,
        widgets_id: Store.state.app.widgets_id,
        rowType: rowType
      })
      col.children.push(module_data)
    }
  }

  // 创建多语言
  create_langs(name, rowType = "header", module_rowType, module_data) {
    const rows = Store.state.myRender[rowType];
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].data.is_system == "true" && rows[i].children.length > 0) {
        //创建一个挂件
        Store.commit("app/ADD_widgets_id");
        let module = null
        if (module_data !== null) {
          module = module_data
          module.rowType = rowType
          module.widgets_id = Store.state.app.widgets_id
          module.pid = rows[i].widgets_id
        } else {
          module = new Module({
            widgets_id: Store.state.app.widgets_id,
            rowType,
            pid: rows[i].widgets_id,
            name
          });
        }
        module.data.isSystem = "true";
        const col = rows[i].children[0];
        if (col && col.children) {
          col.children.unshift(module);
        }
        break;
      }
    }
    // 删除挂件
    if (module_data !== null) {
      this.del_module_data(module_rowType, module_data)
    }
    if(Store.state.app.scrollType === 'normal') {
      // 自动定位
      setTimeout(() => {
        let widgets_id = Store.state.app.widgets_id
        let top = $(`#u${widgets_id}`).offset().top
        console.log('自动定位',top)
        $("html,body").animate({
            scrollTop: top,
          }, 0)
      }, 100);
    } else {
      if(window.fullPage) {
        window.fullPage.resetData()
        window.fullPage.resetHeight()
        if (Store.state.myRender.private.banner_isShow) {
          // 如果有横幅，就要往下滚一页
          window.fullPage.next()
        }
        if(rowType == 'footer') {
          window.fullPage.goLastPageOrFooter()
        } else {
          $('.mb_body_view').css({
            transform: 'translateY(0px)'
          })
        }
      }
    }
  }

  del_module_data(rowType = "header", module_data) {
    let column
    let moduleIndex
    Store.state.myRender[rowType].map((row) => {
      row.children.map((col) => {
        col.children.map((module, index) => {
          if (module.widgets_id === module_data.widgets_id) {
            column = col
            moduleIndex = index
          }
        })
      })
    })
    this.del_module(column.widgets_id, moduleIndex)
  }

  //H1添加
  h1_add_isShow() {
    //检查顶部是否存在导航或网站标题，没有则插入一个
    const module = this.use_name_find_module("body", 'basic_h1');
    //如果没有，则直接插入一个新的
    if (module == null) {
      this.add_h1_to_body()
    }
  }

  //在中部新增H1
  add_h1_to_body() {
    //创建一个row
    Store.commit('app/ADD_widgets_id');
    const row = new Row({
      widgets_id: Store.state.app.widgets_id,
      rowType: 'body',
    });

    Store.commit('app/ADD_widgets_id');
    const col = new Col({
      widgets_id: Store.state.app.widgets_id,
      rowType: 'body',
      pid: row.widgets_id
    });
    col.data.pc_infor.col = 12;

    //创建挂件
    Store.commit('app/ADD_widgets_id');
    const module = new Module({
      widgets_id: Store.state.app.widgets_id,
      rowType: 'body',
      pid: col.widgets_id,
      name: 'basic_h1'
    });
    //module.data.isSystem = "true";

    col.children.push(module);

    row.children.push(col);

    Store.state.myRender.body.unshift(row);

  }


  //amp无该功能
  amp_no_make() {
    if (Store.state.app.language != 'zh-cn' && Store.state.app.view_pattern == 'mb') {
      this.p_$message.warning(i18n.t('base_row_y _ 副本_1941'));
      return true
    }
  }

  copy_col(row, new_row) {
    let cols = []
    for (let i = 0; i < row.children.length; i++) {
      const col = row.children[i];
      const new_col = this.copy_one_col(col, row, new_row);
      // let children = [];
      // Store.commit('app/ADD_widgets_id');
      // const new_col = new Col({
      //   widgets_id: Store.state.app.widgets_id,
      //   rowType: row.rowType,
      //   pid: new_row.widgets_id,
      //   data: col.data,
      //   children: []
      // });
      // if (col.children && col.children instanceof Array) {
      //   children = this.copy_module(col, new_col);
      // }
      //new_col.children = children;
      cols.push(new_col);
    }
    return cols;

  }

  //复制一个列 row是原来的列，new_row 复制出来新的列
  copy_one_col(copy_col, row, new_row) {
    const col = JSON.parse(JSON.stringify(copy_col));

    let children = [];
    Store.commit('app/ADD_widgets_id');
    const new_col = new Col({
      widgets_id: Store.state.app.widgets_id,
      rowType: row.rowType,
      pid: new_row.widgets_id,
      // isNewCol: row.isNewCol,
      // newType: row.newType,
      isNewCol: col.isNewCol,
      newType: col.newType,
      data: col.data,
      children: []
    });
    new_col.data.col_id = gen_id();//生成一个新的列id
    if (col.isNewCol && col.newType === 'col1') {
      children = this.copy_row_list(col.children)
    } else {
      if (col.children && col.children instanceof Array) {
        children = this.copy_module(col, new_col);
      }
    }

    new_col.children = children;

    return new_col;
  }

  //初始化列排序数组,列排序的老数据兼容
  col_order_array_init(row) {
    if (typeof row.data.col_order_array === 'undefined') {
      row.data.col_order_array = [];
    }
    if (typeof row.data.col_order_val === 'undefined') {
      row.data.col_order_val = 'default';
    }
    // 排序错误兼容处理
    const col_array = row.children.map(item => item.data.col_id)
    if (row.data.col_order_array.length > 0) {
      const res = row.data.col_order_array.every(item => col_array.includes(item))
      if(!res) row.data.col_order_array = [];
    }

    const is_push = row.data.col_order_array.length == 0 ? true : false;

    row.children.map((item, i) => {
      if (is_push) {
        row.data.col_order_array.push(item.data.col_id);
      }

      if (typeof item.data.mb_infor.order === 'undefined' ) {
        item.data.mb_infor.order = i;
      }

      //pc_infor部分属性兼容
      if (typeof item.data.pc_infor.padding_pattern === 'undefined') {
        item.data.pc_infor.padding_pattern = 'default';
        item.data.pc_infor.margin_pattern = 'default';
        item.data.pc_infor.margin_top = '0%';
        item.data.pc_infor.margin_bottom = '0%';
        item.data.pc_infor.margin_left = '0%';
        item.data.pc_infor.margin_right = '0%';
      }

      //列排序的老数据兼容
      if (typeof item.data.mb_infor.margin_pattern === 'undefined') {
        item.data.mb_infor = Object.assign(item.data.mb_infor, create_col_style());
      }
    })


  }


//列排序对比
  col_orders_create(orders, cols) {
    const new_cols = [];
    orders.map((o_val) => {
      cols.map((c_val) => {
        if (o_val === c_val.data.col_id) {
          new_cols.push(c_val);
        }
      })
    });
    return new_cols;
  }

  calculation_col_num(col, row) {
    if (Store.state.app.view_pattern === 'pc') {
      return 'pc_col_' + col.data.pc_infor.col;
    } else {
      if (row.data.col_order_val === 'default') {
        return 'mb_col_' + col.data.mb_infor.col;
      } else {
        //如果是自定义模式，用order找到原本的col，用那个的col
        const cols = row.children;
        const order = col.data.mb_infor.order;
        let num = cols[order].data.mb_infor.col;
        return 'mb_col_' + num;
      }
    }
  }

  showMessage(res) {
    let message
    if (res.message === i18n.t('base_row_y _ 副本_1942')) {
      message = i18n.t('base_row_y _ 副本_1943')
      $('.init_mongolia_layer').css({
        zIndex: 99
      })
      $('.entry_btn,.topBar').css({
        zIndex: 98
      })
      Message.error(message)
      setTimeout(() => {
        $('.init_mongolia_layer').css({
          zIndex: 9999
        })
      }, 5 * 1000)
    } else {
      message = res.message
      Message.error(message)
    }

  }
  getParams () {
    const url = decodeURI(window.location.href)
    const params = {}
    if (url.indexOf('?') !== -1) {
      var str = url.substr(url.indexOf('?') + 1)
      var strs = str.split('&')
      for (let i = 0; i < strs.length; i++) {
        params[strs[i].split('=')[0]] = (strs[i].split('=')[1])
      }
    }
    return params
  }

  getPageDesignParams(type,fn=null) {
    let obj = {}
    const params = this.getParams()
    const routerList = ['product_index','case_index','article_index','video_index','help_index','download_index','product','case','article','video','help']
    if(routerList.includes(Store.state.app.now_page)) {
      //差异化设计的数据类型：1产品分类，2新闻分类，3帮助分类，4案例分类，5视频分类，6下载分类，7产品详情，8新闻详情，9帮助详情，10案例详情，11视频详情，12下载详情
      const objType = {
        'product_index': 1,
        'article_index': 2,
        'help_index': 3,
        'case_index': 4,
        'video_index': 5,
        'download_index': 6,
        'product': 7,
        'article': 8,
        'help': 9,
        'case': 10,
        'video': 11,
        'download': 12
      }
      obj.dataType = objType[Store.state.app.now_page] ? objType[Store.state.app.now_page] : null
      obj.dataId = params.id ? params.id : params.typeId
      if(typeof obj.dataId == 'undefined') {
        obj.dataId = -1
      }
      if(type == 'save') {
        obj.designType = Store.state.app.designType
      } else if(typeof fn === 'object' && typeof fn.designType !== 'undefined') {
        obj.designType = fn.designType
      }
    }
    return obj
  }
  getModuleByWidgetsId(rowType,widgets_id) {
    let module_data = null
    Store.state.myRender[rowType].map((row) => {
      row.children.map((col) => {
        col.children.map((module, index) => {
          if (module.widgets_id === widgets_id) {
            module_data = module
          }
        })
      })
    })
    return module_data
  }
}



// WEBPACK FOOTER //
// ./src/base/row_y.js